(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-verification-popup"]) return;
  try {
    
    const button = document.getElementById('age-validator-fail');
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const errorContainer = document.getElementById('age-error-container');
      errorContainer.classList.remove('hidden');
    });

    const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
      const handlers = trapFocus._handlers || (trapFocus._handlers = {});
      const getFocusableElements = (container) => {
        return Array.from(
          container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
          )
        );
      };
      const remove = (focusTarget = null) => {
        document.removeEventListener('focusin', handlers.focusin);
        document.removeEventListener('focusout', handlers.focusout);
        document.removeEventListener('keydown', handlers.keydown);
        if (focusTarget) focusTarget.focus();
      };
      if (!shouldTrap) {
        remove(elementToFocus);
        return;
      }
      const elements = getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];
      remove();
      handlers.keydown = (event) => {
        if (event.code.toUpperCase() !== 'TAB') return;
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
        if (!container.contains(document.activeElement)) {
          event.preventDefault();
          first.focus();
        }
      };
      handlers.focusin = (event) => {
        if (
          event.target !== container &&
          event.target !== last &&
          event.target !== first
        ) return;
        document.addEventListener('keydown', handlers.keydown);
      };
      handlers.focusout = () => {
        document.removeEventListener('keydown', handlers.keydown);
      };
      document.addEventListener('focusin', handlers.focusin);
      document.addEventListener('focusout', handlers.focusout);
      elementToFocus.focus();
      if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
        ) {
          elementToFocus.setSelectionRange(0, elementToFocus.value.length);
        }
    };

  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if ((this.dataset.desktopHidden && window.screen.width > 991) || (this.dataset.mobileHidden && window.screen.width < 768)) return;
      this.button = this.querySelector('button');
      if(!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }
      const toggleModal = (event) => {
        event.preventDefault();
        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      }
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if(!customElements.get('modal-component-toggler')) customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalComponentAgePopup extends HTMLElement {
    constructor() {
      super();
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.initPopupBehavior();
    }
    initPopupBehavior() {
      const storageKey = this.dataset.storageKey;
      const storageValue = this.dataset.storageValue || null;
      if (storageKey && localStorage.getItem(storageKey) === storageValue) {
        this.remove();
        return;
      }
      if (!window.location.href.includes('challenge') || !this.classList.contains('modal--active')) {
        if (this.dataset.trigger === 'self') {
          this.open();
          return;
        }
        this.onScroll = this.showOnScroll.bind(this);
        this.delay = parseInt(this.dataset.delay || "0", 10);
        window.addEventListener('scroll', this.onScroll);
      }
    }
    showOnScroll() {
      if (window.scrollY > this.delay) {
        window.removeEventListener('scroll', this.onScroll);
        this.open();
      }
    }
    doAnimate(){
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }
    open(toggler = null){
      this.toggler = toggler;
      this.parent = this.parentElement;
      if(this.dataset.trigger !== 'self') document.body.append(this);
      this.setClasses(true);
      this.doAnimate();
      trapFocus(this.content);
      this.setListeners(true);
    }
    close(){
      if(this.dataset.trigger !== 'self'){
        document.body.removeChild(this);
        if(this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if(this.toggler){
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag){
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    setListeners(flag){
      if(this.dataset.hideOutside === 'false') return;
      switch(flag){
        case true:
          this.addEventListener('keyup', this.onKeyUp);
          this.addEventListener('click', this.onBodyClick);
          break;
        default:
          this.removeEventListener('keyup', this.onKeyUp);
          this.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onKeyUp(event){
      if(event.key === 'Escape') this.close();
    }
    onBodyClick(event){
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if(boundings.contains(target) || target === boundings) return;
      this.close();
    }
  }
  if(!customElements.get('modal-component-age-popup')) customElements.define('modal-component-age-popup', ModalComponentAgePopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-content"] && !Shopify.designMode) return;
  try {
    
  class SectionScaler extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const vh = window.innerHeight;
      const totalSlides = parseInt(this.dataset.totalInners, 10);
      let currentValue = 0;
      let targetValue = 0;
      let rafId = null;
      const updateInertia = () => {
        currentValue += (targetValue - currentValue) * 0.05; // smoothness here by reducing the value
        this.style.setProperty('--animate-value', currentValue.toFixed(3));
        rafId = requestAnimationFrame(updateInertia);
      };
      const handleScroll = () => {
        const sectionTop = this.offsetTop;
        const scrolledInSection = window.scrollY - sectionTop;
        let section = scrolledInSection / vh;
        section = Math.max(0, Math.min(section, totalSlides));
        targetValue = section;
      };
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              window.addEventListener("scroll", handleScroll, { passive: true });
              if (!rafId) rafId = requestAnimationFrame(updateInertia);
            } else {
              window.removeEventListener("scroll", handleScroll);
              if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = null;
              }
            }
          });
        },
        {
          root: null,
          rootMargin: `-100% 0px 0px 0px`,
          threshold: 0,
        }
      );
      this.observer.observe(this);
    }
  }
  if (!customElements.get("section-scaler")) { customElements.define("section-scaler", SectionScaler); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback(){
      if(!this.querySelector('.marquee-component_col')) return;
      const setOnPause = () => {
        const container = this.querySelector('.marquee-component');
        if(container) {
          container.style.setProperty('--marquee-play-state', 'paused');
        }
      }
      const setOnResume = () => {
        const container = this.querySelector('.marquee-component');
        if(container) {
          container.style.setProperty('--marquee-play-state', 'running');
        }
      };
      const setContainer = (size, container) => {
        if(this.dataset.rotation){
          container.style.height = size + 'px';
        } else{
          container.style.width = size + 'px';
        }
        container.classList.remove('marquee-component--h-scroll', 'marquee-component--v-scroll');
      }
      const setTabIndexing = () => {
        const focusables = this.querySelectorAll('[class*="cloned"] a', '[class*="cloned"] button');
        focusables.forEach(element => {
          element.tabIndex = -1;
          element.setAttribute('aria-hidden', 'true');
        });
      }
      const getColumnsSize = () => {
        let widths = 0;
        const columns = this.querySelectorAll('.marquee-component_col');
        columns.forEach(column => {
          const bounds = column.getBoundingClientRect();
          widths += this.dataset.rotation ? bounds.height : bounds.width;
        });
        return widths;
      }
      const getOriginalColumnsSize = () => {
        let widths = 0;
        const columns = this.querySelectorAll('.marquee-component_col:not([class*="cloned"])');
        columns.forEach(column => {
          const bounds = column.getBoundingClientRect();
          widths += this.dataset.rotation ? bounds.height : bounds.width;
        });
        return widths;
      }
      const initialize = () => {
        const container = this.querySelector('.marquee-component');
        if(!container) return;
        setTabIndexing();
        const originalColumnsSize = getOriginalColumnsSize();
        if(originalColumnsSize === 0) return;
        const totalSize = getColumnsSize();
        if(totalSize > 0) setContainer(totalSize, container);
        const speed = parseFloat(this.dataset.speed) || 10;
        const duration = (originalColumnsSize * speed) / 1000;
        const isForward = this.dataset.direction === 'forward';
        const animationName = this.dataset.rotation ? (isForward ? 'marquee-vertical-forward' : 'marquee-vertical-reverse') : (isForward ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style.setProperty('--marquee-distance', originalColumnsSize + 'px');
        container.style.setProperty('--marquee-duration', duration + 's');
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
      }
      if(this.dataset.pauseOnHover === 'true'){ this.addEventListener('mouseenter', setOnPause.bind(this)); this.addEventListener('mouseleave', setOnResume.bind(this)); }
      this.initLoad = setTimeout(initialize.bind(this), 2000);
      document.addEventListener('DOMContentLoaded', () => this.initLoad);
    }
  }
  if (!customElements.get('marquee-component')) { customElements.define('marquee-component', MarqueeComponent); }

  class StickerElement extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback(){
      const element = this.querySelector(this.dataset.selector);
      if(!element) return;
      const initialize = () => {
        const boundings = element.getBoundingClientRect();
        const height = boundings.height;
        this.style.setProperty('--element-height', (Math.round(height) + 'px'));
      }
      this.initLoad = setTimeout(initialize.bind(this), 2000);
      document.addEventListener('DOMContentLoaded', () => this.initLoad);
    }
  }
  if (!customElements.get('sticker-element')) { customElements.define('sticker-element', StickerElement); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.anchor = this.querySelector('a');
      this.anchor.addEventListener('click', this.onClickRef.bind(this));
    }

    onClickRef() {
      event.preventDefault();
      const targetId = this.anchor.getAttribute('href');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        if (this.dataset.offset) {
          let offset = 0;
          const offsetElement = document.querySelector(this.dataset.offset);
          if (!offsetElement) {
            doScroll();
            if (targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return;
          }
          const elementPosition = targetElement.getBoundingClientRect().top;
          offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
          window.scrollTo({
            top: offset,
            behavior: 'smooth',
          });
          if (targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
          return;
        }
        doScroll();
        if (targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
      }

      function doScroll() {
        targetElement.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
  }
  if (!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      ) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if(!loader) return;
    if(state){
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease'
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease'
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => arr.push(document.querySelector(selector)));
    return arr;
  };
  const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem.querySelectorAll('[data-update-link]');
    if(!links || links.length === 0) return;
    links.forEach(link => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    this.currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    setStatuses(this.currentVariant, formsSelector, renders, parentSelector);
    if(!this.currentVariant) return;
    if(this.currentVariant.featured_image) setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    updateLinks(this.currentVariant.id, parentSelector);
    renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector);
  };
  const changeText = (element, text) => {
    for (const node of element.childNodes) {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = text;
        break;
      }
    }
  }
  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = form.querySelector('[name="add"]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      if(variant.available){
        changeText(atcBtn, atcBtn.dataset.textAvail);
        atcBtn.removeAttribute('disabled');
        return;
      }
      changeText(atcBtn, atcBtn.dataset.textSold);
      atcBtn.setAttribute('disabled', '');
    });
  };
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
      const imageContainer = document.querySelector(arr[0]);
      var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
      var newOpacity = (currentOpacity === 1) ? 0 : 1;
      imageContainer.style.transition = 'opacity 0.3s ease';
      imageContainer.style.opacity = newOpacity;
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        setTimeout(() => {
          imageContainer.style.opacity = 1;
        }, 0);
      }, 500);
      return
    }
    arr.forEach(gallery => {
      const gal = document.querySelector(gallery);
      if(!gal) return;
      switch(gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
          if(activeIndex === -1 || activeIndex === items[activeIndex]) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          let slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          if(slide[0]) return splide.go(slide[0].index);
          gal.querySelector(`[data-media-id="${imageId}"]`)?.scrollIntoView({behavior:'smooth',block:'center',inline:'center'});
          break;
      }
    });
  };
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector) => {
    toggleLoader(true);
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const parentElement = document.querySelector(parent);
        const arr = JSON.parse(elems);
        arr.forEach(selector => {
          const element = parentElement.querySelector(selector);
          if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
        });
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
        toggleLoader(false);
      }
    );
  };
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const element = parentElem.querySelector(selector);
      if(!element) return;
      flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
    });
    if(!btn) return;
    changeText(btn, btn.dataset.textUnavail);
    btn.setAttribute('disabled', '');
  };
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const html = new DOMParser() .parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    toggleLoader(true);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        toggleLoader(false);
        if(!this.error){
          if(element.dataset.selfModal){
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      }
    );
  }
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  class VariantDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content.querySelectorAll('[data-btn-variant]');
      if (!this.button || !this.content || !this.items) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback(){
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const select = (event) => {
        event.preventDefault();
        const form = document.getElementById(self.dataset.formId);
        const input = self.querySelector('[data-submit-input]');
        if (!input || !form) return;
        input.value = event.currentTarget.dataset.value;
        form.submit();
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        self.items.forEach(item => {item.addEventListener('click', self.variantSelect);});
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
      };
      const closeDropdown = () => {
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        trapFocus(null, self.button, false);
        self.items.forEach(item => {item.removeEventListener('click', self.variantSelect);});
        document.body.removeEventListener('click', onBodyClick);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          target === self.button && self.button.getAttribute('aria-expanded') === 'true'
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        closeDropdown();
      };
      const setVariantOptions = (value) => {
        const parent = document.querySelector(this.dataset.parent);
        const errElem = document.querySelector(this.dataset.errorSelector);
        const selElem = document.querySelector(this.dataset.selectedParent);
        if(!parent) return;
        if(errElem) errElem.classList.add('hidden');
        if(selElem) selElem.innerText = value;
        const currentSet = JSON.parse(this.dataset.currentSet);
        const index = parseInt(this.dataset.optionIndex);
        currentSet[index] = value;
        const pills = parent.querySelectorAll('variant-pill, variant-dropdown');
        pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
        setOptions(pills, currentSet);
        let availableSet = null;
        if(this.dataset.checkSets === 'true'){
          const sets = JSON.parse(this.dataset.availableSets);
          const checkSet = (val) => {
            if (!val || !Array.isArray(sets)) return null;
            return sets.find(set => set.includes(val));
          };
          availableSet = checkSet(value);
        }
        onVariantChange(this.dataset.jsonSelector, availableSet ? availableSet : currentSet, this.dataset.forms, this.dataset.renders, this.dataset.mainParent, this.dataset.galleries, this.dataset.sectionId, this.dataset.productUrl, this.dataset.updateUrl, this.dataset.focusSelector ? this.dataset.focusSelector : null, this.dataset.mediaTemplate === 'true' ? true : false, this.dataset.mediaTemplate === 'true' ? this.dataset.template : null);
      };
      const setOptions = (elems, set) => {
        const json = document.querySelector(this.dataset.jsonSelector);
        const data = JSON.parse(json.textContent);
        const variants = data.variants;
        const selectedOptionOneVariants = variants.filter(variant => set[0] === variant.option1);
        elems.forEach((select, index) => {
          if (index === 0) return;
          const optionInputs = [...select.querySelectorAll('[data-btn-variant]')];
          const previousOptionSelected = elems[index - 1].querySelector('[data-btn-variant].product-card_select-option--active').dataset.value;
          const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
          setAvailability(optionInputs, availableOptionInputsValue);
        });
      }
      const setAvailability = (listOfOptions, listOfAvailableOptions) => {
        listOfOptions.forEach(elem => {
          const labelText = elem.querySelector('[data-variant-status-text]');
          if (listOfAvailableOptions.includes(elem.getAttribute('data-value'))){
            labelText.classList.add('hidden');
            return;
          }
          labelText.classList.remove('hidden');
        });
      }
      const setCurrentValue = (target) => {
        const elem = self.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setVariantOptions(target.dataset.value);
        closeDropdown();
      }
      const onVariantSelect = (event) => {
        const target = event.target;
        self.items.forEach(item => item.classList.remove('product-card_select-option--active'));
        target.classList.add('product-card_select-option--active');
        setCurrentValue(target);
      }
      this.variantSelect = onVariantSelect;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('variant-dropdown')) { customElements.define('variant-dropdown', VariantDropdown); }
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onAddToCart = (event) => {
        event.preventDefault();
        this.error = false;
        this.recipientForm = this.form.querySelector('recipient-form');
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetchAtc(secArr, config, this);
      };
      this.submit = onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      ) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class LocalizationDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.items = this.content.querySelectorAll('[data-submit-btn]');
      if (!this.items) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const select = (event) => {
        event.preventDefault();
        const form = document.getElementById(self.dataset.formId);
        const input = self.querySelector('[data-submit-input]');
        if (!input || !form) return;
        input.value = event.currentTarget.dataset.value;
        form.submit();
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
        self.items.forEach((item) => item.addEventListener('click', select));
      };
      const closeDropdown = () => {
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        trapFocus(null, self.button, false);
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
        self.items.forEach((item) => item.removeEventListener('click', select));
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          target === self.button && self.button.getAttribute('aria-expanded') === 'true'
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        closeDropdown();
      };
      this.select = select;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('localization-dropdown')) { customElements.define('localization-dropdown', LocalizationDropdown); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };

  class SearchDropdown extends HTMLElement {
    constructor() {
      super();
      this.searchTerm = '';
      this.cachedResults = [];
      this.abortController = new AbortController();
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.input = this.querySelector('input[name="q"]');
      this.form = this.querySelector('form[role="search"]');
      this.btnSubmit = null;
      this.resultsContainers = {
        predictiveCollections: this.querySelector('[data-render-predictive-collections]'),
        predictiveProducts: this.querySelector('[data-render-predictive-products]'),
        predictiveListings: this.querySelector('[data-render-predictive-listings]'),
        predictiveBtn: this.querySelector('[data-render-predictive-btn]'),
      };
      this.initHtml = {
        predictiveCollections: this.resultsContainers.predictiveCollections?.innerHTML || '',
        predictiveProducts: this.resultsContainers.predictiveProducts?.innerHTML || '',
        predictiveListings: this.resultsContainers.predictiveListings?.innerHTML || '',
        predictiveBtn: this.resultsContainers.predictiveBtn?.innerHTML || '',
      };
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const debounce = (fn, wait) => {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      };
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const onSubmit = (event) => {
        event.preventDefault();
        this.form.submit();
      };
      const fetchSearchResults = (terms) => {
        toggleLoader(true);
        fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(terms)}&section_id=predictive-organizer`, {
          signal: this.abortController.signal,
        })
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              throw error;
            }
            return response.text();
          })
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const searchObj = {
              searchTerm: this.searchTerm,
              contentHtml: html,
            };
            this.cachedResults.push(searchObj);
            const arr = JSON.parse(this.dataset.renders);
            arr.forEach((selector) => {
              const element = document.querySelector(selector);
              if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
            });
            self.btnSubmit = self.querySelector('[data-btn-submit]');
            self.btnSubmit.addEventListener('click', self.onSubmit);
            toggleLoader(false);
          })
          .catch((error) => {
            toggleLoader(false);
            if (error?.code === 20) {
              throw error;
            }
          });
      };
      const showCachedResults = (data, cache) => {
        const cacheDataArr = cache;
        const cachedResults = cacheDataArr.find((results) => results.searchTerm === data.searchTerm);
        const arr = JSON.parse(this.dataset.renders);
        arr.forEach((selector) => {
          const element = document.querySelector(selector);
          if (element && cachedResults.contentHtml.querySelector(selector))
            element.innerHTML = cachedResults.contentHtml.querySelector(selector).innerHTML;
        });
      };
      const onInputType = (event) => {
        const inputValueTerm = this.input.value.replace(/\s/g, '');
        if (inputValueTerm.length > 0) {
          this.searchTerm = this.input.value.trim();
          const term = { searchTerm: this.searchTerm };
          if (!this.cachedResults || !this.cachedResults.some((key) => key.searchTerm === term.searchTerm)) {
            fetchSearchResults(this.searchTerm);
            return;
          }
          showCachedResults(term, this.cachedResults);
          return;
        }
        Object.entries(this.resultsContainers).forEach(([key, container]) => {
          if (container) container.innerHTML = this.initHtml[key] || '';
        });
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        trapFocus(self.content);
        self.addEventListener('keyup', onKeyUp);
        document.body.addEventListener('click', onBodyClick);
        if (this.dataset.predictive === 'true') self.input.addEventListener('input', self.debouncedOnSubmit);
        self.input.focus();
      };
      const closeDropdown = () => {
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        trapFocus(null, self.button, false);
        self.removeEventListener('keyup', onKeyUp);
        document.body.removeEventListener('click', onBodyClick);
        if (this.dataset.predictive === 'true') self.input.removeEventListener('input', self.debouncedOnSubmit);
        if (self.btnSubmit) self.btnSubmit.removeEventListener('click', self.onSubmit);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        closeDropdown();
      };
      this.debouncedOnSubmit = debounce((event) => {
        this.onInputType(event);
      }, 500);
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
      if (this.dataset.predictive === 'true') this.onInputType = onInputType;
      if (this.dataset.predictive === 'true') this.onSubmit = onSubmit;
    }
  }
  if (!customElements.get('search-dropdown')) {
    customElements.define('search-dropdown', SearchDropdown);
  }

  class MenuDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }

    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if (self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('menu-dropdown')) {
    customElements.define('menu-dropdown', MenuDropdown);
  }

  class StickyBlock extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (!this.dataset.refBlock && !this.dataset.behavior) return;
      const stickyHide = () => {
        this.setAttribute('data-revealed', false);
        if (this.dataset.hasHidden === 'true') this.setAttribute('aria-hidden', true);
        if (this.dataset.bodyClass) document.body.classList.remove(this.dataset.bodyClass);
        if (this.height) {
          this.style.removeProperty('height');
          if (this.dataset.bodyClass) document.body.style.removeProperty('--page-header-height');
        }
      };
      const initialize = () => {
        this.behavior = this.dataset.behavior;
        this.spacer = this.dataset.spacer;
        this.endBounds = document.body.offsetHeight + this.offsetHeight;
        if (this.behavior) {
          switch (this.behavior) {
            case 'downwards':
              window.addEventListener('scroll', onDownwardScroll.bind(this));
              break;
            case 'upwards':
              window.addEventListener('scroll', onUpwardScroll.bind(this));
              break;
            case 'stacked':
              window.addEventListener('scroll', onStackedScroll.bind(this));
              break;
            case 'observer':
              window.addEventListener('scroll', onObservedScroll.bind(this));
              break;
            default:
              console.log('init sticky block');
              break;
          }
        }
        this.refBlock = document.querySelector(this.dataset.refBlock);
        if (!this.refBlock) return;
        this.refBoundings = this.refBlock.getBoundingClientRect();
        this.offset = this.dataset.offset ? parseFloat(this.dataset.offset) : 0;
        this.threshold = this.refBlock.offsetTop + this.refBoundings.height + this.offset;
        this.previousScrollAmount = window.screenY;
        this.percent = this.dataset.pagePercentage ? this.dataset.pagePercentage : null;
        if (this.spacer) this.height = this.refBlock.offsetHeight;
      };
      const onObservedScroll = () => {
        let revealedAttr = true;
        const handleObserver = (entries, observer) => {
          observer.unobserve(this);
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              revealedAttr = false;
            } else {
              revealedAttr = true;
            }
            setStickyStatus(revealedAttr);
          });
        };
        new IntersectionObserver(handleObserver, { rootMargin: '0px 0px -60px 0px' }).observe(this);
      };
      const onDownwardScroll = () => {
        let revealedAttr = false;
        if (this.percent) {
          const pageHeight = document.documentElement.offsetHeight;
          const threshold = (pageHeight * parseFloat(this.percent)) / 100;
          this.threshold = threshold;
        }
        if (window.scrollY > this.threshold) revealedAttr = true;
        // dropdownClose();
        setStickyStatus(revealedAttr);
      };
      const onUpwardScroll = () => {
        let revealedAttr = false;
        const threshold = this.height ? this.height : this.refBlock.offsetHeight;

        if (window.scrollY > this.previousScrollAmount) {
          revealedAttr = false;
        } else if (window.scrollY < this.previousScrollAmount) {
          revealedAttr = true;
          // dropdownClose();
          if (window.scrollY < threshold) revealedAttr = false;
        }
        setStickyStatus(revealedAttr);
        this.previousScrollAmount = window.scrollY;
      };
      const onStackedScroll = () => {
        let revealedAttr = false;
        if (this.refBoundings.y < 0) this.refBoundings.y += window.scrollY;
        if (this.refBoundings.y < window.scrollY) revealedAttr = true;
        // dropdownClose();
        setStickyStatus(revealedAttr);
      };
      const setStickyStatus = (revealed) => {
        if (this.dataset.hideOnEnd === 'true')
          if (window.innerHeight + window.scrollY >= this.endBounds) return stickyHide();
        if (revealed) {
          this.setAttribute('data-revealed', true);
          if (this.dataset.hasHidden === 'true') this.removeAttribute('aria-hidden');
          if (this.dataset.bodyClass) document.body.classList.add(this.dataset.bodyClass);
          if (this.height) {
            this.style.height = this.height + 'px';
            if (this.dataset.bodyClass) document.body.style.setProperty('--page-header-height', this.height + 'px');
          }
          return;
        }
        stickyHide();
      };
      const setTempoStatus = (flag, refContainer) => {
        const refElement = document.querySelector(refContainer);
        if (!refElement) return;
        refElement.style.transform = flag ? 'translateY(0%)' : 'translateY(-100%)';
      };
      this.setTempoStatus = setTempoStatus;
      this.setStickyStatus = setStickyStatus;
      this.initLoad = setTimeout(initialize.bind(this), 100);
      document.addEventListener('DOMContentLoaded', function () {
        this.initLoad;
      });
    }
  }
  if (!customElements.get('sticky-block')) {
    customElements.define('sticky-block', StickyBlock);
  }

  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        if (this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-component-toggler'))
    customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalCartRenderComponent extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      const applyColorScheme = (body) => {
        const { colorScheme, destroyQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        body.classList.add(...classes);
      };
      applyColorScheme(this.querySelector('.modal-component_wrapper'));
    }
    open(toggler = null) {
      this.toggler = toggler;
      this.parent = this.parentElement;
      document.body.append(this);
      this.renderModal();
    }
    setClasses(flag) {
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    close() {
      const parent = this.querySelector(this.dataset.selector);
      parent.innerHTML = '';
      if (this.dataset.trigger !== 'self') {
        document.body.removeChild(this);
        if (this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if (this.toggler) {
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    renderModal() {
      toggleLoader(true);
      const fetchUrl = this.dataset.url
        ? `${this.dataset.url}&section_id=${this.dataset.section}`
        : `${window.shopUrl}?section_id=${this.dataset.section}`;
      fetch(fetchUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector(`#${this.dataset.renderSelector}`);
          const parent = this.querySelector(this.dataset.selector);
          parent.innerHTML = html.innerHTML;
        })
        .catch((e) => {
          console.error(e);
          throw e;
        })
        .finally(() => {
          this.setClasses(true);
          this.doAnimate();
          trapFocus(this.content);
          this.setListeners(true);
          toggleLoader(false);
        });
    }
    doAnimate() {
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }
    onBodyClick(event) {
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if (boundings.contains(target) || target === boundings) return;
      this.close();
    }
    onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }
    setListeners(flag) {
      if (this.dataset.hideOutside === 'false') return;
      switch (flag) {
        case true:
          this.addEventListener('keyup', this.onKeyUp);
          this.addEventListener('click', this.onBodyClick);
          break;
        default:
          this.removeEventListener('keyup', this.onKeyUp);
          this.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
  }
  if (!customElements.get('modal-cart-render-component'))
    customElements.define('modal-cart-render-component', ModalCartRenderComponent);

  class ModalMenuComponent extends HTMLElement {
    constructor() {
      super();

      if (this.dataset.desktopHidden === 'true' && window.screen.width > 991) return;
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      // Apply color scheme on initialization
      this.applyColorScheme();
    }
    applyColorScheme() {
      const wrapper = this.querySelector('.modal-component_wrapper');
      if (!wrapper || !this.dataset.colorScheme) return;
      const classes = this.dataset.colorScheme.trim().split(/\s+/);
      wrapper.classList.add(...classes);
    }
    open(toggler = null) {
      this.toggler = toggler;
      this.parent = this.parentElement;
      if (this.dataset.trigger !== 'self') document.body.append(this);
      // Re-apply color scheme after moving to body
      this.applyColorScheme();
      this.setClasses(true);
      this.doAnimate();
      trapFocus(this.content);
      this.setListeners(true);
    }
    doAnimate() {
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }
    close() {
      if (this.dataset.trigger !== 'self') {
        document.body.removeChild(this);
        if (this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if (this.toggler) {
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag) {
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    setListeners(flag) {
      if (this.dataset.hideOutside === 'false') return;
      switch (flag) {
        case true:
          this.addEventListener('keyup', this.onKeyUp);
          this.addEventListener('click', this.onBodyClick);
          break;
        default:
          this.removeEventListener('keyup', this.onKeyUp);
          this.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onBodyClick(event) {
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if (boundings.contains(target) || target === boundings) return;
      this.close();
    }
    onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }
  }
  if (!customElements.get('modal-menu-component')) customElements.define('modal-menu-component', ModalMenuComponent);

  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  class QuantityInput extends HTMLElement {
    constructor() {
      super();

      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === 'plus' || event.target.parentElement.name === 'plus'
          ? this.input.stepUp()
          : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      };

      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn =
          type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      };

      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      };

      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]');
        this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value);
        if (!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      };

      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.buttonClick));
      };

      const initialize = () => {
        this.input = this.querySelector('input');
        if (!this.input) return;
        setListeners();
      };
      initialize();
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }

    connectedCallback() {
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 500);
      this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
    }

    onLineItemUpdate() {
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if (!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);

  const sectionArrRender = (secArr, response) => {
    secArr.forEach((section) => {
      const html = new DOMParser()
        .parseFromString(response.sections[section.id], 'text/html')
        .getElementById(section.id);
      section.selectors.forEach((selector) => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };

  const handleLineError = (parent, response) => {
    const parentElement = document.querySelector(parent);
    const errorContainer = parentElement.querySelector('[data-render-error]');
    errorContainer.classList.remove('hidden');
    errorContainer.innerText = response.errors;
    const qtyInput = parentElement.querySelector('input[name="updates[]"]');
    qtyInput.value = parseFloat(parentElement.dataset.initQty);
    toggleLoader(false);
    return (this.erorr = true);
  };

  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }

  const lineItemUpdate = (line, quantity, sections, parent) => {
    toggleLoader(true);
    const secArr = JSON.parse(sections);
    var body = JSON.stringify({
      line,
      quantity,
      sections: secArr.map((section) => section.id),
      sections_url: window.location.pathname,
    });
    this.erorr = false;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if (response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (!this.erorr) {
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if (modal) {
            if (modal.classList.contains('modal--active')) {
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
        toggleLoader(false);
      });
  };

  if (!customElements.get('line-item-remove')) {
    customElements.define(
      'line-item-remove',
      class LineItemRemoveButton extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
        }

        connectedCallback() {
          if (!this.button) return;

          const onRemoval = (event) => {
            event.preventDefault();
            lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector);
          };
          this.removal = onRemoval.bind(this);
          this.button.addEventListener('click', this.removal);
        }
      }
    );
  }

  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  if (!customElements.get('shipping-bar')) {
    customElements.define(
      'shipping-bar',
      class ShippingBar extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          const setString = () => {
            const dataRate = parseFloat(this.dataset.amount);
            const rateFactor = Shopify.currency.rate || 1;
            const amountCalc = dataRate * rateFactor;
            const cartTotals = parseFloat(this.dataset.cartTotals) / 100;
            const amount = (amountCalc - cartTotals) * 100;

            const textContainer = this.querySelector('.shipping-bar_text');
            if (textContainer) {
              if (amount > 0) {
                const base = textContainer.innerHTML;
                textContainer.innerHTML = base.replace(
                  /\|\|amount\|\|/g,
                  Shopify.formatMoney(amount, window.money_format)
                );
              } else {
                textContainer.innerHTML = window.cartStrings.shippingAmount;
              }
            }

            this.threshold = amountCalc;
            this.cartTotals = cartTotals;
          };

          const setBar = () => {
            const element = this.querySelector('progress');
            if (!element) return;
            const value = (this.cartTotals / this.threshold) * 100;
            element.setAttribute('value', value.toFixed(2));
            element.innerText = value.toFixed(2);
          };
          setString();
          setBar();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback(){
      if(!this.querySelector('.marquee-component_col')) return;
      const setOnPause = () => {
        const container = this.querySelector('.marquee-component');
        if(container) {
          container.style.setProperty('--marquee-play-state', 'paused');
        }
      }
      const setOnResume = () => {
        const container = this.querySelector('.marquee-component');
        if(container) {
          container.style.setProperty('--marquee-play-state', 'running');
        }
      };
      const setContainer = (size, container) => {
        if(this.dataset.rotation){
          container.style.height = size + 'px';
        } else{
          container.style.width = size + 'px';
        }
        container.classList.remove('marquee-component--h-scroll', 'marquee-component--v-scroll');
      }
      const setTabIndexing = () => {
        const focusables = this.querySelectorAll('[class*="cloned"] a', '[class*="cloned"] button');
        focusables.forEach(element => {
          element.tabIndex = -1;
          element.setAttribute('aria-hidden', 'true');
        });
      }
      const getColumnsSize = () => {
        let widths = 0;
        const columns = this.querySelectorAll('.marquee-component_col');
        columns.forEach(column => {
          const bounds = column.getBoundingClientRect();
          widths += this.dataset.rotation ? bounds.height : bounds.width;
        });
        return widths;
      }
      const getOriginalColumnsSize = () => {
        let widths = 0;
        const columns = this.querySelectorAll('.marquee-component_col:not([class*="cloned"])');
        columns.forEach(column => {
          const bounds = column.getBoundingClientRect();
          widths += this.dataset.rotation ? bounds.height : bounds.width;
        });
        return widths;
      }
      const initialize = () => {
        const container = this.querySelector('.marquee-component');
        if(!container) return;
        setTabIndexing();
        const originalColumnsSize = getOriginalColumnsSize();
        if(originalColumnsSize === 0) return;
        const totalSize = getColumnsSize();
        if(totalSize > 0) setContainer(totalSize, container);
        const speed = parseFloat(this.dataset.speed) || 10;
        const duration = (originalColumnsSize * speed) / 1000;
        const isForward = this.dataset.direction === 'forward';
        const animationName = this.dataset.rotation ? (isForward ? 'marquee-vertical-forward' : 'marquee-vertical-reverse') : (isForward ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style.setProperty('--marquee-distance', originalColumnsSize + 'px');
        container.style.setProperty('--marquee-duration', duration + 's');
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
      }
      if(this.dataset.pauseOnHover === 'true'){ this.addEventListener('mouseenter', setOnPause.bind(this)); this.addEventListener('mouseleave', setOnResume.bind(this)); }
      this.initLoad = setTimeout(initialize.bind(this), 2000);
      document.addEventListener('DOMContentLoaded', () => this.initLoad);
    }
  }
  if (!customElements.get('marquee-component')) { customElements.define('marquee-component', MarqueeComponent); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (var key in params) {
      var hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  const selectors = {
    customerAddresses: '[data-customer-addresses]',
    addressCountrySelect: '[data-address-country-select]',
    addressContainer: '[data-address]',
    toggleAddressButton: 'button[data-address-button]',
    cancelAddressButton: 'button[type="reset"]',
    deleteAddressButton: 'button[data-confirm-message]',
  };

  const attributes = {
    expanded: 'aria-expanded',
    confirmMessage: 'data-confirm-message',
  };

  class CustomerAddresses {
    constructor() {
      this.elements = this._getElements();
      if (Object.keys(this.elements).length === 0) return;
      this._setupCountries();
      this._setupEventListeners();
    }

    _getElements() {
      const container = document.querySelector(selectors.customerAddresses);
      return container
        ? {
            container,
            addressContainer: container.querySelector(selectors.addressContainer),
            toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
            cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
            deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
            countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
          }
        : {};
    }

    _setupCountries() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
          hideElement: 'AddressProvinceContainerNew',
        });
        this.elements.countrySelects.forEach((select) => {
          const formId = select.dataset.formId;
          // eslint-disable-next-line no-new
          new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
            hideElement: `AddressProvinceContainer_${formId}`,
          });
        });
      }
    }

    _setupEventListeners() {
      this.elements.toggleButtons.forEach((element) => {
        element.addEventListener('click', this._handleAddEditButtonClick);
      });
      this.elements.cancelButtons.forEach((element) => {
        element.addEventListener('click', this._handleCancelButtonClick);
      });
      this.elements.deleteButtons.forEach((element) => {
        element.addEventListener('click', this._handleDeleteButtonClick);
      });
    }

    _toggleExpanded(target) {
      target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
    }

    _handleAddEditButtonClick = ({ currentTarget }) => {
      this._toggleExpanded(currentTarget);
    };

    _handleCancelButtonClick = ({ currentTarget }) => {
      this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
    };

    _handleDeleteButtonClick = ({ currentTarget }) => {
      // eslint-disable-next-line no-alert
      if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
        Shopify.postLink(currentTarget.dataset.target, {
          parameters: { _method: 'delete' },
        });
      }
    };
  }

  window.addEventListener('load', () => {
    typeof CustomerAddresses !== 'undefined' && new CustomerAddresses();
  });

  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      ) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
  };

  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if ((this.dataset.desktopHidden && window.screen.width > 991) || (this.dataset.mobileHidden && window.screen.width < 768)) return;
      this.button = this.querySelector('button');
      if(!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }
      const toggleModal = (event) => {
        event.preventDefault();
        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      }
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if(!customElements.get('modal-component-toggler')) customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalAddressComponent extends HTMLElement {
    constructor() {
      super();
      if ((this.dataset.desktopHidden && window.screen.width > 991) || (this.dataset.mobileHidden && window.screen.width < 768)) return;
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('.modal-component_wrapper');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      const applyColorScheme = (body) => {
        const { colorScheme, destroyQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        body.classList.add(...classes);
      };
      applyColorScheme(this.querySelector('.modal-component_wrapper'));
    }
    open(toggler = null){
      this.toggler = toggler;
      this.parent = this.parentElement;
      if(this.dataset.trigger !== 'self') document.body.append(this);
      this.setClasses(true);
      this.doAnimate();
      trapFocus(this.content);
      this.setListeners(true);
    }
    doAnimate(){
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }
    close(){
      if(this.dataset.trigger !== 'self'){
        document.body.removeChild(this);
        if(this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if(this.toggler){
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag){
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    setListeners(flag){
      if(this.dataset.hideOutside === 'false') return;
      switch(flag){
        case true:
          this.addEventListener('keyup', this.onKeyUp);
          this.addEventListener('click', this.onBodyClick);
          break;
        default:
          this.removeEventListener('keyup', this.onKeyUp);
          this.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onBodyClick(event){
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if(boundings.contains(target) || target === boundings) return;
      this.close();
    }
    onKeyUp(event){
      if(event.key === 'Escape') this.close();
    }
  }
  if(!customElements.get('modal-address-component')) customElements.define('modal-address-component', ModalAddressComponent);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  class DropdownComponent extends HTMLElement {
    constructor() {
      super();
      if(this.dataset.desktopHidden === 'true' && window.screen.width > 767) return;
      if(this.dataset.desktopHidden === 'wide' && window.screen.width > 991) return;
      this.button = this.querySelector('.dropdown-component_opener');
      this.content = this.querySelector('.dropdown-component_wrapper');
      if(!this.button || !this.content) return;
      this.onButtonClick = this.toggleDropdown.bind(this);
      this.onButtonClose = this.close.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.button.addEventListener('click', this.onButtonClick);
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if(this.closeButton) this.closeButton.addEventListener('click', this.onButtonClose);
      if(this.dataset.onHover === 'true' && window.screen.width > 1025){
        this.addEventListener('mouseenter', this.onButtonClick);
        this.addEventListener('mouseleave', this.onButtonClose);
      }
    }

    open(){
      this.button.setAttribute('aria-expanded', true);
      this.content.classList.add('dropdown--open');
      this.content.focus();
      trapFocus(this.content);
      document.body.addEventListener('click', this.onBodyClick);
      this.addEventListener('keyup', this.onKeyUp);
    }

    close(){
      this.button.setAttribute('aria-expanded', false);
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.content, false);
      document.body.removeEventListener('click', this.onBodyClick);
      this.removeEventListener('keyup', this.onKeyUp);
    }

    toggleDropdown(event){
      if(event.target.getAttribute('aria-expanded') === 'true') return this.close();
      this.open();
    }

    onBodyClick(event){
      const target = event.target;
      if(this.contains(target) || target === this || target === this.button
        && this.button.getAttribute('aria-expanded') === 'true') return;
      this.doClose(event);
    }

    onKeyUp(event){
      if(event.key !== 'Escape') return;
      this.doClose(event);
    }

    doClose(event){
      if(this.dataset.level === '2'){
        event.stopPropagation();
        this.close();
        this.button.focus();
        const parentDropdown = this.closest('dropdown-component[data-level="1"]');
        if(parentDropdown && parentDropdown.content) trapFocus(parentDropdown.content);
        return;
      }
      this.close();
      this.button.focus();
    }
  }
  if(!customElements.get('dropdown-component')) customElements.define('dropdown-component', DropdownComponent);

  class ShareComponent extends DropdownComponent {
    constructor() {
      super();

      this.urlInput = this.querySelector('.shareUrl');
      if(navigator.share){
        this.button.removeEventListener('click', this.onButtonClick);
        this.button.addEventListener('click', () => { navigator.share({ url: this.urlInput.value, title: document.title }); });
        this.classList.add('--share-native');
        return;
      }
      this.classList.remove('--share-native');
      this.successMessage = this.querySelector('.shareMessage');
      this.shareButton = this.querySelector('.share-button__copy');
      this.label = this.querySelector('.share-button__label');
      this.shareButton.addEventListener('click', this.copyToClipboard.bind(this));
    }

    toggleDetails(){
      this.successMessage.classList.add('hidden');
      this.successMessage.textContent = '';
      this.closeButton.classList.add('hidden');
      this.label.classList.remove('hidden');
    }

    copyToClipboard(){
      navigator.clipboard.writeText(this.urlInput.value).then(() => {
        this.successMessage.classList.remove('hidden');
        this.successMessage.textContent = window.accessibilityStrings.shareSuccess;
        this.closeButton.classList.remove('hidden');
        this.label.classList.add('hidden');
      });
    }

    close(){
      super.close();
      this.toggleDetails();
    }
  }
  if(!customElements.get('share-component')) customElements.define('share-component', ShareComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  class TruncateText extends HTMLElement {
    constructor() {
      super();
      this.truncateLength = parseInt(this.getAttribute('truncate-length')) || 5;
      this.originalText = '';
      this.isExpanded = false;
      this.toggleButton = null;
    }

    connectedCallback() {
      const toggleButton = this.querySelector('.toggle-text');
      if (!toggleButton) return;

      this.toggleButton = toggleButton;
      toggleButton.remove();

      this.originalText = this.innerHTML.trim();
      this.appendChild(toggleButton);

      toggleButton.addEventListener('click', this.toggleTruncate.bind(this));
      this.truncateContent();
    }

    truncateContent() {
      const words = this.originalText.trim().split(/\s+/);
      if (words.length <= this.truncateLength) {
        this.toggleButton.style.display = 'none';
        return;
      }

      this.innerHTML = '';

      // Use Shopify translation text stored in data attributes
      const readMoreText = this.dataset.readMoreText || window.read_more_text || 'Read more';
      const readLessText = this.dataset.readLessText || window.read_less_text || 'Read less';

      if (!this.isExpanded) {
        const truncatedText = words.slice(0, this.truncateLength).join(' ') + '... ';
        this.appendChild(document.createTextNode(truncatedText));
        this.toggleButton.textContent = readMoreText;
      } else {
        this.appendChild(document.createTextNode(this.originalText));
        this.toggleButton.textContent = readLessText;
      }

      this.appendChild(this.toggleButton);
    }

    toggleTruncate(event) {
      event.preventDefault();
      this.isExpanded = !this.isExpanded;
      this.truncateContent();
    }
  }
  if (!customElements.get('truncate-text')) {
    customElements.define('truncate-text', TruncateText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      ) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };

  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if(!loader) return;
    if(state){
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease'
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease'
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };

  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  class QuantityInput extends HTMLElement {
    constructor() {
      super();

      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        (event.target.name === 'plus' || event.target.parentElement.name === 'plus') ? this.input.stepUp() : this.input.stepDown();
        if(previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      }

      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn = type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      }

      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      }

      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]');
        (this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value));
        if(!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      }

      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.buttonClick));
      }

      const initialize = () => {
        this.input = this.querySelector('input');
        if(!this.input) return;
        setListeners();
      }
      initialize();
    }
  }
  if(!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

  class LineItemQty extends QuantityInput {
    constructor() {
      super();
    }

    connectedCallback(){
      this.inputUpdate = this.querySelector('[name="updates[]"]');
      this.debouncedOnUpdate = debounce((event) => {
        this.onLineItemUpdate(event);
      }, 500);
      this.inputUpdate.addEventListener('input', this.debouncedOnUpdate);
    }

    onLineItemUpdate(){
      const qty = parseInt(this.querySelector('[name="updates[]"]').value);
      lineItemUpdate(this.dataset.lineId, qty, this.dataset.sections, this.dataset.parentSelector);
    }
  }
  if(!customElements.get('line-item-qty')) customElements.define('line-item-qty', LineItemQty);

  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const html = new DOMParser() .parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  }

  const handleLineError = (parent, response) => {
    const parentElement = document.querySelector(parent);
    const errorContainer = parentElement.querySelector('[data-render-error]');
    errorContainer.classList.remove('hidden');
    errorContainer.innerText = response.errors;
    const qtyInput = parentElement.querySelector('input[name="updates[]"]');
    qtyInput.value = parseFloat(parentElement.dataset.initQty);
    toggleLoader(false);
    return this.erorr = true;
  }

  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }

  const lineItemUpdate = (line, quantity, sections, parent) => {
    toggleLoader(true);
    const secArr = JSON.parse(sections);
    var body = JSON.stringify({
      line,
      quantity,
      sections: secArr.map(section => section.id),
      sections_url: window.location.pathname
    });
    this.erorr = false;
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        const response = JSON.parse(responseText);
        if(response.errors) return handleLineError(parent, response);
        sectionArrRender(secArr, response);
      }).catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(!this.erorr){
          const modal = document.querySelector('[data-modal="modal-cart-drawer"]');
          if(modal){
            if(modal.classList.contains('modal--active')){
              trapFocus(modal.content);
              modal.setListeners(true);
            }
          }
        }
        toggleLoader(false);
      }
    );
  }

  if (!customElements.get('line-item-remove')) {
    customElements.define('line-item-remove', class LineItemRemoveButton extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
      }

      connectedCallback(){
        if(!this.button) return;

        const onRemoval = (event) => {
          event.preventDefault();
          lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector)
        }
        this.removal = onRemoval.bind(this);
        this.button.addEventListener('click', this.removal);
      }
    });
  }

  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  if (!customElements.get('shipping-bar')) {
    customElements.define('shipping-bar', class ShippingBar extends HTMLElement {
      constructor() {
        super();
      }
      
      connectedCallback(){
        const setString = () => {
          const dataRate = parseFloat(this.dataset.amount);
          const rateFactor = Shopify.currency.rate || 1;
          const amountCalc = dataRate * rateFactor;
          const cartTotals = parseFloat(this.dataset.cartTotals) / 100;
          const amount = (amountCalc - cartTotals) * 100;

          const textContainer = this.querySelector('.shipping-bar_text');
          if (textContainer) {
            if (amount > 0) {
              const base = textContainer.innerHTML;
              textContainer.innerHTML = base.replace(/\|\|amount\|\|/g, Shopify.formatMoney(amount, window.money_format));
            } else {
              textContainer.innerHTML = window.cartStrings.shippingAmount;
            }
          }

          this.threshold = amountCalc;
          this.cartTotals = cartTotals;
        }
        
        const setBar = () => {
          const element = this.querySelector('progress');
          if(!element) return;
          const value = (this.cartTotals / this.threshold) * 100;
          element.setAttribute('value', value.toFixed(2));
          element.innerText = value.toFixed(2);
        }
        setString();
        setBar();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  const btnToForgot = document.getElementById('toForgot');
  const btnToLogin = document.getElementById('toLogin');
  if (!btnToForgot || !btnToLogin) return;
  const loginWrapper = document.getElementById('login-wrapper');
  const forgetWrapper = document.getElementById('forget-wrapper');
  function fadeOut(element, callback) {
    element.style.opacity = 1;
    function animate() {
      element.style.opacity -= 0.1;
      if (parseFloat(element.style.opacity) <= 0) {
        element.setAttribute('hidden', '');
        element.style.opacity = '';
        if (callback) callback();
      } else {
        requestAnimationFrame(animate);
      }
    }
    requestAnimationFrame(animate);
  }
  function fadeIn(element) {
    element.removeAttribute('hidden');
    element.style.opacity = 0;
    function animate() {
      element.style.opacity = parseFloat(element.style.opacity) + 0.1;
      if (parseFloat(element.style.opacity) < 1) return requestAnimationFrame(animate);
      element.style.opacity = '';
      focusFirstInput(element);
    }
    requestAnimationFrame(animate);
  }
  function focusFirstInput(wrapper) {
    const input = wrapper.querySelector('input[type="email"]');
    if (input) input.focus();
  }
  function switchToRecover() {
    loginWrapper.setAttribute('hidden', '');
    forgetWrapper.removeAttribute('hidden');
    focusFirstInput(forgetWrapper);
  }
  btnToForgot.addEventListener('click', function (e) {
    e.preventDefault();
    fadeOut(loginWrapper, () => fadeIn(forgetWrapper));
  });
  btnToLogin.addEventListener('click', function (e) {
    e.preventDefault();
    fadeOut(forgetWrapper, () => fadeIn(loginWrapper));
  });
  window.addEventListener('DOMContentLoaded', () => {
    const successElement = document.getElementById('recoveremail-email-success');
    if (window.location.hash === '#recover' || successElement) {
      switchToRecover();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  const btnToAccess = document.getElementById('toAccess');
  const btnToDefault = document.getElementById('toDefault');
  if (!btnToAccess || !btnToDefault) return;
  const loginWrapper = document.getElementById('direct-wrapper');
  const forgetWrapper = document.getElementById('access-wrapper');
  function fadeOut(element, callback) {
    element.style.opacity = 1;
    function animate() {
      element.style.opacity -= 0.1;
      if (parseFloat(element.style.opacity) <= 0) {
        element.setAttribute('hidden', '');
        element.style.opacity = '';
        if (callback) callback();
      } else {
        requestAnimationFrame(animate);
      }
    }
    requestAnimationFrame(animate);
  }
  function fadeIn(element) {
    element.removeAttribute('hidden');
    element.style.opacity = 0;
    function animate() {
      element.style.opacity = parseFloat(element.style.opacity) + 0.1;
      if (parseFloat(element.style.opacity) < 1) return requestAnimationFrame(animate);
      element.style.opacity = '';
      focusFirstInput(element);
    }
    requestAnimationFrame(animate);
  }
  function focusFirstInput(wrapper, pass) {
    const input = wrapper.querySelector('input[type="email"]') || wrapper.querySelector('input[type="password"]');
    if (input) input.focus();
  }
  function switchToRecover() {
    loginWrapper.setAttribute('hidden', '');
    forgetWrapper.removeAttribute('hidden');
    focusFirstInput(forgetWrapper);
  }
  btnToAccess.addEventListener('click', function (e) {
    e.preventDefault();
    fadeOut(loginWrapper, () => fadeIn(forgetWrapper));
  });
  btnToDefault.addEventListener('click', function (e) {
    e.preventDefault();
    fadeOut(forgetWrapper, () => fadeIn(loginWrapper));
  });
  window.addEventListener('DOMContentLoaded', () => {
    const errorElement = document.getElementById('EnterForm-password-error');
    if (errorElement) switchToRecover();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (screen.width > 991) {
    const sideCols = document.querySelectorAll('.main-product_sticky-wrap');
    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      sideCols.forEach((col) => {
        const rect = col.getBoundingClientRect();
        const colTop = col.offsetTop;
        const colHeight = col.offsetHeight;
        const maxScroll = colHeight * 0.1; // same as scrollY * factor max limit
        const newY = Math.max(-maxScroll, -scrollY * 0.1);
        col.style.transform = `translateY(${newY}px)`;
      });
    });
  }

  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if (!strArr) return (arr = null);
    strArr.forEach((selector) => arr.push(document.querySelector(selector)));
    return arr;
  };
  const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem.querySelectorAll('[data-update-link]');
    if (!links || links.length === 0) return;
    links.forEach((link) => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };
  const onVariantChange = (
    jsonSelector,
    optSet,
    formsSelector,
    renders,
    parentSelector,
    gallerySelectors,
    sectionId,
    productUrl,
    updateUrl,
    focusSelector,
    renderMedia,
    templateSelector
  ) => {
    const json = document.querySelector(jsonSelector);
    if (!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    this.currentVariant = variants.find((variant) =>
      variant.options.every((option, index) => option === optSet[index])
    );
    setStatuses(this.currentVariant, formsSelector, renders, parentSelector);
    if (!this.currentVariant) return;
    if (this.currentVariant.featured_image)
      setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    updateLinks(this.currentVariant.id, parentSelector);
    renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector);
  };
  const changeText = (element, text) => {
    for (const node of element.childNodes) {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = text;
        break;
      }
    }
  };
  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const forms = getJsonParse(formElems);
    forms.forEach((form) => {
      if (!form) return;
      const atcBtn = form.querySelector('[name="add"]');
      if (!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if (!atcBtn) return;
      if (variant.available) {
        changeText(atcBtn, atcBtn.dataset.textAvail);
        atcBtn.removeAttribute('disabled');
        return;
      }
      changeText(atcBtn, atcBtn.dataset.textSold);
      atcBtn.setAttribute('disabled', '');
    });
  };
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if (render) {
      const templateElem = document.querySelector(template);
      const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
      const imageContainer = document.querySelector(arr[0]);
      var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
      var newOpacity = currentOpacity === 1 ? 0 : 1;
      imageContainer.style.transition = 'opacity 0.3s ease';
      imageContainer.style.opacity = newOpacity;
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        setTimeout(() => {
          imageContainer.style.opacity = 1;
        }, 0);
      }, 500);
      return;
    }
    arr.forEach((gallery) => {
      const gal = document.querySelector(gallery);
      if (!gal) return;
      switch (gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          const activeIndex = items.findIndex((item) => item.dataset.mediaId == imageId);
          if (activeIndex === -1 || activeIndex === items[activeIndex]) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          let slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          if (slide[0]) return splide.go(slide[0].index);
          gal
            .querySelector(`[data-media-id="${imageId}"]`)
            ?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
          break;
      }
    });
  };
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector) => {
    toggleLoader(true);
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const parentElement = document.querySelector(parent);
        const arr = JSON.parse(elems);
        arr.forEach((selector) => {
          const element = parentElement.querySelector(selector);
          if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
        });
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if (updateUrl === 'true') window.history.replaceState({}, '', `${url}?variant=${id}`);
        if (focusSelector) {
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
        toggleLoader(false);
      });
  };
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach((selector) => {
      const element = parentElem.querySelector(selector);
      if (!element) return;
      flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
    });
    if (!btn) return;
    changeText(btn, btn.dataset.textUnavail);
    btn.setAttribute('disabled', '');
  };
  const sectionArrRender = (secArr, response) => {
    secArr.forEach((section) => {
      const html = new DOMParser()
        .parseFromString(response.sections[section.id], 'text/html')
        .getElementById(section.id);
      section.selectors.forEach((selector) => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if (!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if (!flag) {
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if (recepForm) recepForm.clearErrorMessage();
      return;
    }
    if (recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if (typeof response.description !== 'object') {
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    toggleLoader(true);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        toggleLoader(false);
        if (!this.error) {
          if (element.dataset.selfModal) {
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if (element.dataset.redirect) return (window.location.href = element.dataset.redirect);
          if (element.dataset.modal === 'true') {
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if (drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      });
  };
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  };
  class DropdownComponent extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.desktopHidden === 'true' && window.screen.width > 767) return;
      if (this.dataset.desktopHidden === 'wide' && window.screen.width > 991) return;
      this.button = this.querySelector('.dropdown-component_opener');
      this.content = this.querySelector('.dropdown-component_wrapper');
      if (!this.button || !this.content) return;
      this.onButtonClick = this.toggleDropdown.bind(this);
      this.onButtonClose = this.close.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.button.addEventListener('click', this.onButtonClick);
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (this.closeButton) this.closeButton.addEventListener('click', this.onButtonClose);
      if (this.dataset.onHover === 'true' && window.screen.width > 1025) {
        this.addEventListener('mouseenter', this.onButtonClick);
        this.addEventListener('mouseleave', this.onButtonClose);
      }
    }

    open() {
      this.button.setAttribute('aria-expanded', true);
      this.content.classList.add('dropdown--open');
      this.content.focus();
      trapFocus(this.content);
      document.body.addEventListener('click', this.onBodyClick);
      this.addEventListener('keyup', this.onKeyUp);
    }

    close() {
      this.button.setAttribute('aria-expanded', false);
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.content, false);
      document.body.removeEventListener('click', this.onBodyClick);
      this.removeEventListener('keyup', this.onKeyUp);
    }

    toggleDropdown(event) {
      if (event.target.getAttribute('aria-expanded') === 'true') return this.close();
      this.open();
    }

    onBodyClick(event) {
      const target = event.target;
      if (
        this.contains(target) ||
        target === this ||
        (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
      )
        return;
      this.doClose(event);
    }

    onKeyUp(event) {
      if (event.key !== 'Escape') return;
      this.doClose(event);
    }

    doClose(event) {
      if (this.dataset.level === '2') {
        event.stopPropagation();
        this.close();
        this.button.focus();
        const parentDropdown = this.closest('dropdown-component[data-level="1"]');
        if (parentDropdown && parentDropdown.content) trapFocus(parentDropdown.content);
        return;
      }
      this.close();
      this.button.focus();
    }
  }
  if (!customElements.get('dropdown-component')) customElements.define('dropdown-component', DropdownComponent);
  class ShareComponent extends DropdownComponent {
    constructor() {
      super();

      this.urlInput = this.querySelector('.shareUrl');
      if (navigator.share) {
        this.button.removeEventListener('click', this.onButtonClick);
        this.button.addEventListener('click', () => {
          navigator.share({ url: this.urlInput.value, title: document.title });
        });
        this.classList.add('--share-native');
        return;
      }
      this.classList.remove('--share-native');
      this.successMessage = this.querySelector('.shareMessage');
      this.shareButton = this.querySelector('.share-button__copy');
      this.label = this.querySelector('.share-button__label');
      this.shareButton.addEventListener('click', this.copyToClipboard.bind(this));
    }

    toggleDetails() {
      this.successMessage.classList.add('hidden');
      this.successMessage.textContent = '';
      this.closeButton.classList.add('hidden');
      this.label.classList.remove('hidden');
    }

    copyToClipboard() {
      navigator.clipboard.writeText(this.urlInput.value).then(() => {
        this.successMessage.classList.remove('hidden');
        this.successMessage.textContent = window.accessibilityStrings.shareSuccess;
        this.closeButton.classList.remove('hidden');
        this.label.classList.add('hidden');
      });
    }

    close() {
      super.close();
      this.toggleDetails();
    }
  }
  if (!customElements.get('share-component')) customElements.define('share-component', ShareComponent);

  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[data-id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', () => {
        if (this.dataset.parent && window.pauseElementBasedMedia) {
          const parentEl = document.querySelector(this.dataset.parent);
          if (parentEl) window.pauseElementBasedMedia(parentEl);
        }
        this._lc();
      });
    }

    connectedCallback() {
      if (this.dataset.playViewport === 'true') {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const poster = this.querySelector('[data-id^="Deferred-Poster-"]');
                if (poster) poster.click();
                const video = this.querySelector('video');
                if (video) video.play();
                const parent = document.querySelector(this.dataset.parent);
                if (parent) parent.classList.add('video-playing');
                observer.unobserve(this);
              }
            });
          },
          { threshold: 1.0 }
        );
        observer.observe(this);
      }
      if (this.dataset.onHover === 'true') {
        this.addEventListener('focusin', this._handleFocus.bind(this), true);
        this.addEventListener('mouseenter', this._handleFocus.bind(this));
      }
      const poster = this.querySelector('[data-id^="Deferred-Poster-"]');
      if (poster && this.dataset.onHover === 'true') {
        poster.setAttribute('tabindex', '0');
        this.addEventListener('keydown', (e) => {
          const poster = this.querySelector('[data-id^="Deferred-Poster-"]');
          if ((e.key === 'Enter' || e.key === ' ') && document.activeElement === poster) {
            e.preventDefault();
            poster.click();
          }
        });
      }
    }

    _handleFocus() {
      if (!this.getAttribute('loaded')) {
        const poster = this.querySelector('[data-id^="Deferred-Poster-"]');
        if (poster) poster.click();
        requestAnimationFrame(() => {
          const video = this.querySelector('video');
          if (video) video.play().catch(() => {});
        });
      } else {
        const video = this.querySelector('video');
        if (video) video.play().catch(() => {});
      }
    }

    _lc(focus = true) {
      this._cp();
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus && deferredElement instanceof HTMLElement) deferredElement.focus();
        if (deferredElement.nodeName === 'VIDEO' && deferredElement.getAttribute('autoplay'))
          deferredElement.play().catch(() => {});
        if (this.dataset.sectionId) {
          const section = document.getElementById(this.dataset.sectionId);
          if (section) section.classList.add('--remove-sliders');
        }
      }
    }

    _cp() {
      if (this.dataset.singleParent === 'true' && this.dataset.parent) {
        const parentElement = document.querySelector(this.dataset.parent);
        parentElement.querySelectorAll('.js-youtube').forEach((video) => {
          video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        });
        parentElement.querySelectorAll('.js-vimeo').forEach((video) => {
          video.contentWindow.postMessage('{"method":"pause"}', '*');
        });
        parentElement.querySelectorAll('video').forEach((video) => video.pause());
        parentElement.querySelectorAll('product-model').forEach((model) => {
          if (model.modelViewerUI) model.modelViewerUI.pause();
        });
        parentElement.querySelectorAll('deferred-media[loaded], product-model[loaded]').forEach((media) => {
          if (media !== this) {
            media.removeAttribute('loaded');
            const poster = media.querySelector('[data-id^="Deferred-Poster-"]');
            if (poster) poster.setAttribute('tabindex', '0');
            const loadedContent = media.querySelector('video, model-viewer, iframe');
            if (loadedContent) loadedContent.remove();
          }
        });
      }
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);
  class ProductModel extends DeferredMedia {
    constructor() {
      super();
    }

    _lc() {
      super._lc();
      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this._smv.bind(this),
        },
      ]);
    }

    _smv(errors) {
      if (errors) return;
      this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
    }
  }
  if (!customElements.get('line-item-remove')) {
    customElements.define(
      'line-item-remove',
      class LineItemRemoveButton extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
        }

        connectedCallback() {
          if (!this.button) return;

          const onRemoval = (event) => {
            event.preventDefault();
            lineItemUpdate(this.dataset.lineId, 0, this.dataset.sections, this.dataset.parentSelector);
          };
          this.removal = onRemoval.bind(this);
          this.button.addEventListener('click', this.removal);
        }
      }
    );
  }
  if (!customElements.get('product-model')) customElements.define('product-model', ProductModel);
  window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: this._sxr.bind(this),
        },
      ]);
    },
    _sxr(errors) {
      if (errors) return;
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', () => this._sxr());
        return;
      }
      document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
        window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
        modelJSON.remove();
      });
      window.ShopifyXR.setupXRElements();
    },
  };
  window.addEventListener(
    'DOMContentLoaded',
    () => window.ProductModel?.loadShopifyXR && window.ProductModel.loadShopifyXR()
  );
  class VariantDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content.querySelectorAll('[data-btn-variant]');
      if (!this.button || !this.content || !this.items) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        self.items.forEach((item) => {
          item.addEventListener('click', self.variantSelect);
        });
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
      };
      const closeDropdown = () => {
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        trapFocus(null, self.button, false);
        self.items.forEach((item) => {
          item.removeEventListener('click', self.variantSelect);
        });
        document.body.removeEventListener('click', onBodyClick);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        closeDropdown();
      };
      const setVariantOptions = (value) => {
        const parent = document.querySelector(this.dataset.parent);
        const errElem = document.querySelector(this.dataset.errorSelector);
        const selElem = document.querySelector(this.dataset.selectedParent);
        if (!parent) return;
        if (errElem) errElem.classList.add('hidden');
        if (selElem) selElem.innerText = value;
        const currentSet = JSON.parse(this.dataset.currentSet);
        const index = parseInt(this.dataset.optionIndex);
        currentSet[index] = value;
        const pills = parent.querySelectorAll('variant-pill, variant-dropdown');
        pills.forEach((pill) => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
        setOptions(pills, currentSet);
        let availableSet = null;
        if (this.dataset.checkSets === 'true') {
          const sets = JSON.parse(this.dataset.availableSets);
          const checkSet = (val) => {
            if (!val || !Array.isArray(sets)) return null;
            return sets.find((set) => set.includes(val));
          };
          availableSet = checkSet(value);
        }
        onVariantChange(
          this.dataset.jsonSelector,
          availableSet ? availableSet : currentSet,
          this.dataset.forms,
          this.dataset.renders,
          this.dataset.mainParent,
          this.dataset.galleries,
          this.dataset.sectionId,
          this.dataset.productUrl,
          this.dataset.updateUrl,
          this.dataset.focusSelector ? this.dataset.focusSelector : null,
          this.dataset.mediaTemplate === 'true' ? true : false,
          this.dataset.mediaTemplate === 'true' ? this.dataset.template : null
        );
      };
      const setOptions = (elems, set) => {
        const json = document.querySelector(this.dataset.jsonSelector);
        const data = JSON.parse(json.textContent);
        const variants = data.variants;
        const selectedOptionOneVariants = variants.filter((variant) => set[0] === variant.option1);
        elems.forEach((select, index) => {
          if (index === 0) return;
          const optionInputs = [...select.querySelectorAll('[data-btn-variant]')];
          const previousOptionSelected = elems[index - 1].querySelector(
            '[data-btn-variant].main-product_select-option--active'
          ).dataset.value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
            .map((variantOption) => variantOption[`option${index + 1}`]);
          setAvailability(optionInputs, availableOptionInputsValue);
        });
      };
      const setAvailability = (listOfOptions, listOfAvailableOptions) => {
        listOfOptions.forEach((elem) => {
          const labelText = elem.querySelector('[data-variant-status-text]');
          if (listOfAvailableOptions.includes(elem.getAttribute('data-value'))) {
            labelText.classList.add('hidden');
            return;
          }
          labelText.classList.remove('hidden');
        });
      };
      const setCurrentValue = (target) => {
        const elem = self.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setVariantOptions(target.dataset.value);
        closeDropdown();
      };
      const onVariantSelect = (event) => {
        const target = event.target;
        self.items.forEach((item) => item.classList.remove('main-product_select-option--active'));
        target.classList.add('main-product_select-option--active');
        setCurrentValue(target);
      };
      this.variantSelect = onVariantSelect;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('variant-dropdown')) {
    customElements.define('variant-dropdown', VariantDropdown);
  }
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = document.querySelector(this.dataset.form);
      if (!this.form) return;
      const onAddToCart = (event) => {
        event.preventDefault();
        this.error = false;
        this.recipientForm = this.form.querySelector('recipient-form');
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append(
          'sections',
          secArr.map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetchAtc(secArr, config, this);
      };
      this.submit = onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }
  }
  if (!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  class RecipientForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.checkboxInput = this.querySelector(`[id*="Recipient-Checkbox"]`);
      this.checkboxInput.disabled = false;
      this.hiddenControlField = this.querySelector(`[id*="Recipient-Control"]`);
      this.hiddenControlField.disabled = true;
      this.emailInput = this.querySelector(`[id*="Recipient-email"]`);
      this.nameInput = this.querySelector(`[id*="Recipient-name"]`);
      this.messageInput = this.querySelector(`[id*="Recipient-message"]`);
      this.sendonInput = this.querySelector(`[id*="Recipient-send-on"]`);
      this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
      this.errorMessageList = this.errorMessageWrapper.querySelector('ul');
      this.errorMessage = this.errorMessageWrapper.querySelector('.error-message');
      this.defaultErrorHeader = this.errorMessage?.innerText;
      this.currentProductVariantId = this.dataset.productVariantId;
      this.addEventListener('change', this.onChange.bind(this));
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }

    clearInputFields(flag = false) {
      if (this.emailInput) this.emailInput.value = '';
      if (this.nameInput) this.nameInput.value = '';
      if (this.messageInput) this.messageInput.value = '';
      if (this.sendonInput) this.sendonInput.value = '';
      if (flag) this.checkboxInput.checked = false;
    }

    displayErrorMessage(title, body) {
      this.clearErrorMessage();
      this.errorMessageWrapper.hidden = false;
      if (typeof body === 'object') {
        this.errorMessage.innerText = this.defaultErrorHeader;
        return Object.entries(body).forEach(([key, value]) => {
          const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}-${this.dataset.productId}`;
          const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}-${this.dataset.productId}`;
          const label = key.includes('send_on') ? '' : key;
          const message = `${label} ${value}`;
          const errorMessageElement = this.querySelector(`#${errorMessageId}`);
          const errorTextElement = errorMessageElement?.querySelector('.error-message');
          if (!errorTextElement) return;
          if (this.errorMessageList)
            this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
          errorTextElement.innerText = `${message}.`;
          errorMessageElement.classList.remove('hidden');
          const inputElement = this[`${key}Input`];
          if (!inputElement) return;
          inputElement.setAttribute('aria-invalid', true);
          inputElement.setAttribute('aria-describedby', errorMessageId);
        });
      }
      this.errorMessage.innerText = body;
    }

    createErrorListItem(target, message) {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.setAttribute('href', target);
      a.innerText = message;
      a.classList.add('errors-list_link');
      li.appendChild(a);
      li.className = 'error-message errors-list_item';
      return li;
    }

    clearErrorMessage() {
      this.errorMessageWrapper.hidden = true;
      if (this.errorMessageList) this.errorMessageList.innerHTML = '';
      this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
        field.classList.add('hidden');
        const textField = field.querySelector('.error-message');
        if (textField) textField.innerText = '';
      });
      [this.emailInput, this.messageInput, this.nameInput].forEach((inputElement) => {
        inputElement.setAttribute('aria-invalid', false);
        inputElement.removeAttribute('aria-describedby');
      });
    }

    resetRecipientForm() {
      if (this.checkboxInput.checked) {
        this.checkboxInput.checked = false;
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }
  }
  if (!customElements.get('recipient-form')) customElements.define('recipient-form', RecipientForm);
  class QuantityInput extends HTMLElement {
    constructor() {
      super();

      const onButtonClick = (event) => {
        event.preventDefault();
        const previousValue = this.input.value;
        event.target.name === 'plus' || event.target.parentElement.name === 'plus'
          ? this.input.stepUp()
          : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      };

      const setBtnStatus = (type, value) => {
        const currVal = type === 'min' ? parseInt(this.input.min) : parseInt(this.input.value);
        const btn =
          type === 'min' ? this.querySelector("button[name='minus']") : this.querySelector("button[name='plus']");
        switch (type) {
          case 'min':
            btn.classList.toggle('disabled', value <= currVal);
            btn.toggleAttribute('disabled', value <= currVal);
            break;
          case 'max':
            btn.classList.toggle('disabled', value >= currVal);
            btn.toggleAttribute('disabled', value >= currVal);
            break;
          default:
            console.log('no button found');
            break;
        }
      };

      const setSubtotals = (qty, elem) => {
        const total = qty * parseInt(this.dataset.variantPrice);
        elem.innerHTML = Shopify.formatMoney(total, window.money_format);
      };

      const onInputChange = () => {
        const value = parseInt(this.input.value);
        const qtySubtotal = this.querySelector('[data-qty-subtotal]');
        this.input.min && setBtnStatus('min', value), this.input.max && setBtnStatus('max', value);
        if (!qtySubtotal) return;
        setSubtotals(value, qtySubtotal);
      };

      const setListeners = () => {
        this.changeEvent = new Event('input', { bubbles: true });
        this.inputChange = onInputChange.bind(this);
        this.buttonClick = onButtonClick.bind(this);
        this.input.addEventListener('input', this.inputChange);
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.buttonClick));
      };

      const initialize = () => {
        this.input = this.querySelector('input');
        if (!this.input) return;
        setListeners();
      };
      initialize();
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        if (this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-component-toggler'))
    customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalComponent extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      const applyColorScheme = (body) => {
        const { colorScheme, destroyQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        body.classList.add(...classes);
      };
      applyColorScheme(this.querySelector('.modal-component_wrapper'));
    }
    open(toggler = null) {
      this.toggler = toggler;
      this.parent = this.parentElement;
      if (this.dataset.trigger !== 'self') document.body.append(this);
      this.setClasses(true);
      trapFocus(this.content);
      this.setListeners(true);
    }
    close() {
      if (this.dataset.trigger !== 'self') {
        document.body.removeChild(this);
        if (this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if (this.toggler) {
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag) {
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    setListeners(flag) {
      if (this.dataset.hideOutside === 'false') return;
      switch (flag) {
        case true:
          this.addEventListener('keyup', this.onKeyUp);
          this.addEventListener('click', this.onBodyClick);
          break;
        default:
          this.removeEventListener('keyup', this.onKeyUp);
          this.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onBodyClick(event) {
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if (boundings.contains(target) || target === boundings) return;
      this.close();
    }
    onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }
  }
  if (!customElements.get('modal-component')) customElements.define('modal-component', ModalComponent);
  class ModalPickupRenderComponent extends ModalComponent {
    constructor() {
      super();
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
    }
    open(toggler = null) {
      this.toggler = toggler;
      this.parent = this.parentElement;
      document.body.append(this);
      this.renderModal();
    }
    setClasses(flag) {
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    close() {
      const parent = this.querySelector(this.dataset.selector);
      parent.innerHTML = '';
      if (this.dataset.trigger !== 'self') {
        document.body.removeChild(this);
        if (this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if (this.toggler) {
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    renderModal() {
      toggleLoader(true);
      const fetchUrl = this.dataset.url
        ? `${this.dataset.url}&section_id=${this.dataset.section}`
        : `${window.shopUrl}?section_id=${this.dataset.section}`;
      fetch(fetchUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector(`#${this.dataset.renderSelector}`);
          const parent = this.querySelector(this.dataset.selector);
          parent.innerHTML = html.innerHTML;
        })
        .catch((e) => {
          console.error(e);
          throw e;
        })
        .finally(() => {
          this.setClasses(true);
          this.doAnimate();
          trapFocus(this.content);
          this.setListeners(true);
          toggleLoader(false);
        });
    }
    doAnimate() {
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }
  }
  if (!customElements.get('modal-pickup-render-component'))
    customElements.define('modal-pickup-render-component', ModalPickupRenderComponent);
  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class ProductRecommendations extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.empty = true;
          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-recommendations');
                if (recommendations && recommendations.innerHTML.trim().length) {
                  this.empty = false;
                  this.innerHTML = recommendations.innerHTML;
                  if (!recommendations.innerHTML.includes('data-recommend-check')) {
                    let recommendationAncestor = this.parentElement;
                    while (recommendationAncestor && !recommendationAncestor.classList.contains('recommendation')) {
                      recommendationAncestor = recommendationAncestor.parentElement;
                    }
                    if (recommendationAncestor) recommendationAncestor.classList.add('hidden');
                  }
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                if (this.empty) this.parentElement.classList.add('hidden');
              });
          };
          new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
        }
      }
    );
  }
  window.addEventListener(
    'DOMContentLoaded',
    () => window.ProductModel?.loadShopifyXR && window.ProductModel.loadShopifyXR()
  );
  Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-products-grid"]) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if (!strArr) return (arr = null);
    strArr.forEach((selector) => arr.push(document.querySelector(selector)));
    return arr;
  };
  const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem.querySelectorAll('[data-update-link]');
    if (!links || links.length === 0) return;
    links.forEach((link) => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };
  const onVariantChange = (
    jsonSelector,
    optSet,
    formsSelector,
    renders,
    parentSelector,
    gallerySelectors,
    sectionId,
    productUrl,
    updateUrl,
    focusSelector,
    renderMedia,
    templateSelector
  ) => {
    const json = document.querySelector(jsonSelector);
    if (!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    this.currentVariant = variants.find((variant) =>
      variant.options.every((option, index) => option === optSet[index])
    );
    setStatuses(this.currentVariant, formsSelector, renders, parentSelector);
    if (!this.currentVariant) return;
    if (this.currentVariant.featured_image)
      setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    updateLinks(this.currentVariant.id, parentSelector);
    renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector);
  };
  const changeText = (element, text) => {
    for (const node of element.childNodes) {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = text;
        break;
      }
    }
  };
  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const forms = getJsonParse(formElems);
    forms.forEach((form) => {
      if (!form) return;
      const atcBtn = form.querySelector('[name="add"]');
      if (!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if (!atcBtn) return;
      if (variant.available) {
        changeText(atcBtn, atcBtn.dataset.textAvail);
        atcBtn.removeAttribute('disabled');
        return;
      }
      changeText(atcBtn, atcBtn.dataset.textSold);
      atcBtn.setAttribute('disabled', '');
    });
  };
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if (render) {
      const templateElem = document.querySelector(template);
      const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
      const imageContainer = document.querySelector(arr[0]);
      var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
      var newOpacity = currentOpacity === 1 ? 0 : 1;
      imageContainer.style.transition = 'opacity 0.3s ease';
      imageContainer.style.opacity = newOpacity;
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        setTimeout(() => {
          imageContainer.style.opacity = 1;
        }, 0);
      }, 500);
      return;
    }
    arr.forEach((gallery) => {
      const gal = document.querySelector(gallery);
      if (!gal) return;
      switch (gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          const activeIndex = items.findIndex((item) => item.dataset.mediaId == imageId);
          if (activeIndex === -1 || activeIndex === items[activeIndex]) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          let slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          if (slide[0]) return splide.go(slide[0].index);
          gal
            .querySelector(`[data-media-id="${imageId}"]`)
            ?.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
          break;
      }
    });
  };
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector) => {
    toggleLoader(true);
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const parentElement = document.querySelector(parent);
        const arr = JSON.parse(elems);
        arr.forEach((selector) => {
          const element = parentElement.querySelector(selector);
          if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
        });
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if (updateUrl === 'true') window.history.replaceState({}, '', `${url}?variant=${id}`);
        if (focusSelector) {
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
        toggleLoader(false);
      });
  };
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach((selector) => {
      const element = parentElem.querySelector(selector);
      if (!element) return;
      flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
    });
    if (!btn) return;
    changeText(btn, btn.dataset.textUnavail);
    btn.setAttribute('disabled', '');
  };
  const sectionArrRender = (secArr, response) => {
    secArr.forEach((section) => {
      const html = new DOMParser()
        .parseFromString(response.sections[section.id], 'text/html')
        .getElementById(section.id);
      section.selectors.forEach((selector) => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if (!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if (!flag) {
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if (recepForm) recepForm.clearErrorMessage();
      return;
    }
    if (recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if (typeof response.description !== 'object') {
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    toggleLoader(true);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        toggleLoader(false);
        if (!this.error) {
          if (element.dataset.selfModal) {
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if (element.dataset.redirect) return (window.location.href = element.dataset.redirect);
          if (element.dataset.modal === 'true') {
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if (drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      });
  };
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  };
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
  const setFilterParam = (param, value, remove = false, getParams = false) => {
    const input = document.getElementById('filters-params');
    const url = new URL(input.value, window.location.origin);
    if (getParams) {
      const params = new URLSearchParams(url.searchParams).toString();
      return params;
    }
    switch (remove) {
      case true:
        if (param.includes('price')) {
          [...url.searchParams.keys()].forEach((key) => key.includes('filter.v.price') && url.searchParams.delete(key));
        } else {
          const valToDel = value;
          const values = url.searchParams.getAll(param);
          const updatedValues = values.filter((value) => value !== valToDel);
          url.searchParams.delete(param);
          updatedValues.forEach((value) => url.searchParams.append(param, value));
        }
        break;
      case 'all':
        [...url.searchParams.keys()].forEach((key) => key.includes('filter') && url.searchParams.delete(key));
        break;
      default:
        if (param.includes('price')) {
          url.searchParams.set(param, value);
        } else {
          url.searchParams.append(param, value);
        }
        break;
    }
    input.value = url.toString();
  };
  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if (
        (this.dataset.desktopHidden && window.screen.width > 991) ||
        (this.dataset.mobileHidden && window.screen.width < 768)
      )
        return;
      this.button = this.querySelector('button');
      if (!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      };
      const toggleModal = (event) => {
        event.preventDefault();
        if (this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if (this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      };
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if (!customElements.get('modal-component-toggler'))
    customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalFilterComponent extends HTMLElement {
    constructor() {
      super();
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
    }
    open(toggler = null) {
      this.toggler = toggler;
      this.parent = this.parentElement;
      document.body.append(this);
      this.renderModal();
    }
    doAnimate() {
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }
    renderModal() {
      toggleLoader(true);
      const sectionId = document.getElementById('modal-section').value;
      const modalParams = document.querySelector('#filters-params');
      fetch(modalParams.value + sectionId)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser()
            .parseFromString(responseText, 'text/html')
            .querySelector(`#${this.dataset.renderSelector}`);
          const parent = this.querySelector(this.dataset.selector);
          parent.innerHTML = html.innerHTML;
        })
        .catch((e) => {
          console.error(e);
          throw e;
        })
        .finally(() => {
          this.setClasses(true);
          this.doAnimate();
          trapFocus(this.content);
          this.initFilters();
          this.setListeners(true);
          toggleLoader(false);
        });
    }
    initFilters() {
      trapFocus(this.content);
      this.setListeners(true);
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
      setTimeout(() => {
        this.classList.add('--rendered');
      }, 500);
      this.fields = this.querySelectorAll('input');
      this.fields.forEach((field) => {
        field.addEventListener('input', this.debouncedOnSubmit.bind(this));
      });
    }
    onSubmitHandler(event) {
      event.preventDefault();
      const target = event.target;
      switch (target.type) {
        case 'checkbox':
          setFilterParam(target.name, target.value, !target.checked);
          break;
        case 'number':
          setFilterParam(target.name, target.value);
          break;
        default:
          console.log('other any');
          break;
      }
      const facetsFilter = document.querySelector('facets-filter');
      facetsFilter.onSubmitHandler(target.id);
    }
    close() {
      this.fields.forEach((field) => {
        field.removeEventListener('input', this.onSubmitHandler.bind(this));
      });
      setTimeout(() => {
        this.classList.add('--rendered');
      }, 500);
      if (this.dataset.trigger !== 'self') {
        document.body.removeChild(this);
        if (this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if (this.toggler) {
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag) {
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    setListeners(flag) {
      if (this.dataset.hideOutside === 'false') return;
      switch (flag) {
        case true:
          this.addEventListener('keyup', this.onKeyUp);
          this.addEventListener('click', this.onBodyClick);
          break;
        default:
          this.removeEventListener('keyup', this.onKeyUp);
          this.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onBodyClick(event) {
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if (boundings.contains(target) || target === boundings) return;
      this.close();
    }
    onKeyUp(event) {
      if (event.key === 'Escape') this.close();
    }
  }
  if (!customElements.get('modal-filter-component'))
    customElements.define('modal-filter-component', ModalFilterComponent);
  class FacetsFilter extends HTMLElement {
    constructor() {
      super();

      this.cachedResults = [];
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    connectedCallback() {
      this.initParams = setFilterParam(null, null, false, true);
    }

    onHistoryChange(event) {
      if (event.state && this.cachedResults.length === 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
        return;
      }

      if (this.cachedResults && this.cachedResults.length > 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = { params: searchParams };
        if (this.cachedResults.some((key) => key.params === term.params))
          return this.renderFromCache(this.cachedResults, term, false);
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
      }
    }

    onSubmitHandler(target) {
      toggleLoader(true);
      const input = document.querySelector('#filters-params');
      let inputValue = input.value;
      if (!inputValue.includes('?')) inputValue = input.value + '?';
      const sectionsInput = document.querySelector('#filters-sections');
      const url = inputValue + sectionsInput.value;
      const searchParams = setFilterParam(null, null, false, true);
      const term = { params: searchParams };
      if (this.cachedResults.length > 0 && this.cachedResults.some((key) => key.params === term.params)) {
        this.renderFromCache(this.cachedResults, term, true, target);
        return;
      }
      this.renderFetch(url, true, searchParams, target);
    }

    renderFetch(url, updateURLHash = false, searchParams, target = null) {
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          const secArr = JSON.parse(this.dataset.sections);
          secArr.forEach((section) => {
            const html = new DOMParser().parseFromString(data[section.id], 'text/html').getElementById(section.id);
            section.selectors.forEach((selector) => {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.outerHTML = sourceElement.outerHTML;
              }
            });
          });
          const cacheObj = { params: searchParams, content: data };
          this.cachedResults.push(cacheObj);
        })
        .catch((e) => {
          console.log(e);
          throw e;
        })
        .finally(() => {
          if (updateURLHash) this.updateURLHash(searchParams);
          const modal = document.querySelector('modal-filter-component.modal--active');
          if (modal) modal.initFilters();
          if (target) {
            const org = document.getElementById(target);
            if (org) org.focus();
          }
          toggleLoader(false);
        });
    }

    renderFromCache(cache, filter, updateURLHash = false, target = null) {
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find((results) => results.params === filter.params);
      const secArr = JSON.parse(this.dataset.sections);
      secArr.forEach((section) => {
        const html = new DOMParser()
          .parseFromString(cachedResults.content[section.id], 'text/html')
          .getElementById(section.id);
        section.selectors.forEach((selector) => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.outerHTML = sourceElement.outerHTML;
          }
        });
      });
      if (updateURLHash) this.updateURLHash(filter.params);
      const modal = document.querySelector('modal-filter-component.modal--active');
      if (modal) modal.initFilters();
      if (target) {
        const org = document.getElementById(target);
        if (org) org.focus();
      }
      toggleLoader(false);
    }

    updateURLHash(searchParams) {
      const updatedSearchParams = setFilterParam(null, null, false, true);
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${updatedSearchParams && '?'.concat(updatedSearchParams)}`
      );
    }
  }
  if (!customElements.get('facets-filter')) customElements.define('facets-filter', FacetsFilter);
  class DropdownComponent extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.desktopHidden === 'true' && window.screen.width > 767) return;
      if (this.dataset.desktopHidden === 'wide' && window.screen.width > 991) return;
      this.button = this.querySelector('.dropdown-component_opener');
      this.content = this.querySelector('.dropdown-component_wrapper');
      if (!this.button || !this.content) return;
      this.onButtonClick = this.toggleDropdown.bind(this);
      this.onButtonClose = this.close.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.button.addEventListener('click', this.onButtonClick);
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (this.closeButton) this.closeButton.addEventListener('click', this.onButtonClose);
      if (this.dataset.onHover === 'true' && window.screen.width > 1025) {
        this.addEventListener('mouseenter', this.onButtonClick);
        this.addEventListener('mouseleave', this.onButtonClose);
      }
    }

    open() {
      this.button.setAttribute('aria-expanded', true);
      this.content.classList.add('dropdown--open');
      this.content.focus();
      trapFocus(this.content);
      document.body.addEventListener('click', this.onBodyClick);
      this.addEventListener('keyup', this.onKeyUp);
    }

    close() {
      this.button.setAttribute('aria-expanded', false);
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.content, false);
      document.body.removeEventListener('click', this.onBodyClick);
      this.removeEventListener('keyup', this.onKeyUp);
    }

    toggleDropdown(event) {
      if (event.target.getAttribute('aria-expanded') === 'true') return this.close();
      this.open();
    }

    onBodyClick(event) {
      const target = event.target;
      if (
        this.contains(target) ||
        target === this ||
        (target === this.button && this.button.getAttribute('aria-expanded') === 'true')
      )
        return;
      this.doClose(event);
    }

    onKeyUp(event) {
      if (event.key !== 'Escape') return;
      this.doClose(event);
    }

    doClose(event) {
      if (this.dataset.level === '2') {
        event.stopPropagation();
        this.close();
        this.button.focus();
        const parentDropdown = this.closest('dropdown-component[data-level="1"]');
        if (parentDropdown && parentDropdown.content) trapFocus(parentDropdown.content);
        return;
      }
      this.close();
      this.button.focus();
    }
  }
  if (!customElements.get('dropdown-component')) customElements.define('dropdown-component', DropdownComponent);
  class SortDropdown extends DropdownComponent {
    constructor() {
      super();

      this.items = this.content.querySelectorAll('[data-btn-sort]');
      if (!this.items) return;
    }

    connectedCallback() {
      const setCurrentValue = (target) => {
        const elem = this.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setFilterParam('sort_by', target.dataset.value);
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
        this.close();
      };

      const onSortSelect = (event) => {
        const target = event.target;
        this.items.forEach((item) => item.classList.remove('active'));
        target.classList.add('active');
        setCurrentValue(target);
      };
      this.sortSelect = onSortSelect.bind(this);
    }

    open() {
      this.items.forEach((item) => {
        item.addEventListener('click', this.sortSelect);
      });
      super.open();
    }

    close() {
      this.items.forEach((item) => {
        item.removeEventListener('click', this.sortSelect);
      });
      super.close();
    }
  }
  if (!customElements.get('sort-dropdown')) customElements.define('sort-dropdown', SortDropdown);
  class VariantDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content.querySelectorAll('[data-btn-variant]');
      if (!this.button || !this.content || !this.items) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const select = (event) => {
        event.preventDefault();
        const form = document.getElementById(self.dataset.formId);
        const input = self.querySelector('[data-submit-input]');
        if (!input || !form) return;
        input.value = event.currentTarget.dataset.value;
        form.submit();
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        self.items.forEach((item) => {
          item.addEventListener('click', self.variantSelect);
        });
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
      };
      const closeDropdown = () => {
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        trapFocus(null, self.button, false);
        self.items.forEach((item) => {
          item.removeEventListener('click', self.variantSelect);
        });
        document.body.removeEventListener('click', onBodyClick);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        closeDropdown();
      };
      const setVariantOptions = (value) => {
        const parent = document.querySelector(this.dataset.parent);
        const errElem = document.querySelector(this.dataset.errorSelector);
        const selElem = document.querySelector(this.dataset.selectedParent);
        if (!parent) return;
        if (errElem) errElem.classList.add('hidden');
        if (selElem) selElem.innerText = value;
        const currentSet = JSON.parse(this.dataset.currentSet);
        const index = parseInt(this.dataset.optionIndex);
        currentSet[index] = value;
        const pills = parent.querySelectorAll('variant-pill, variant-dropdown');
        pills.forEach((pill) => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
        setOptions(pills, currentSet);
        let availableSet = null;
        if (this.dataset.checkSets === 'true') {
          const sets = JSON.parse(this.dataset.availableSets);
          const checkSet = (val) => {
            if (!val || !Array.isArray(sets)) return null;
            return sets.find((set) => set.includes(val));
          };
          availableSet = checkSet(value);
        }
        onVariantChange(
          this.dataset.jsonSelector,
          availableSet ? availableSet : currentSet,
          this.dataset.forms,
          this.dataset.renders,
          this.dataset.mainParent,
          this.dataset.galleries,
          this.dataset.sectionId,
          this.dataset.productUrl,
          this.dataset.updateUrl,
          this.dataset.focusSelector ? this.dataset.focusSelector : null,
          this.dataset.mediaTemplate === 'true' ? true : false,
          this.dataset.mediaTemplate === 'true' ? this.dataset.template : null
        );
      };
      const setOptions = (elems, set) => {
        const json = document.querySelector(this.dataset.jsonSelector);
        const data = JSON.parse(json.textContent);
        const variants = data.variants;
        const selectedOptionOneVariants = variants.filter((variant) => set[0] === variant.option1);
        elems.forEach((select, index) => {
          if (index === 0) return;
          const optionInputs = [...select.querySelectorAll('[data-btn-variant]')];
          const previousOptionSelected = elems[index - 1].querySelector(
            '[data-btn-variant].product-card_select-option--active'
          ).dataset.value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
            .map((variantOption) => variantOption[`option${index + 1}`]);
          setAvailability(optionInputs, availableOptionInputsValue);
        });
      };
      const setAvailability = (listOfOptions, listOfAvailableOptions) => {
        listOfOptions.forEach((elem) => {
          const labelText = elem.querySelector('[data-variant-status-text]');
          if (listOfAvailableOptions.includes(elem.getAttribute('data-value'))) {
            labelText.classList.add('hidden');
            return;
          }
          labelText.classList.remove('hidden');
        });
      };
      const setCurrentValue = (target) => {
        const elem = self.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setVariantOptions(target.dataset.value);
        closeDropdown();
      };
      const onVariantSelect = (event) => {
        const target = event.target;
        self.items.forEach((item) => item.classList.remove('product-card_select-option--active'));
        target.classList.add('product-card_select-option--active');
        setCurrentValue(target);
      };
      this.variantSelect = onVariantSelect;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('variant-dropdown')) {
    customElements.define('variant-dropdown', VariantDropdown);
  }
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = document.querySelector(this.dataset.form);
      if (!this.form) return;
      const onAddToCart = (event) => {
        event.preventDefault();
        this.error = false;
        this.recipientForm = this.form.querySelector('recipient-form');
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append(
          'sections',
          secArr.map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetchAtc(secArr, config, this);
      };
      this.submit = onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }
  }
  if (!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  if (!customElements.get('grid-load-more')) {
    customElements.define(
      'grid-load-more',
      class GridLoadMore extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button');
        }

        connectedCallback() {
          if (!this.button) return;

          const initialize = () => {
            if (this.dataset.infinite === 'true') this.requested = false;
            setListeners();
          };

          const setListeners = () => {
            const loadMore = onLoadMore.bind(this);
            this.button.addEventListener('click', loadMore);

            if (this.dataset.infinite === 'true') {
              window.addEventListener('scroll', loadInfinite.bind(this));
            }
          };

          const loadInfinite = () => {
            const handleObserver = (entries, observer) => {
              observer.unobserve(this);
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  if (this.requested) return;
                  this.button.dispatchEvent(new Event('click'));
                  this.requested = true;
                } else {
                  this.requested = false;
                }
              });
            };

            new IntersectionObserver(handleObserver, { rootMargin: '0px 0px -60px 0px' }).observe(this);
          };

          const onLoadMore = (event) => {
            event.preventDefault();
            this.button.classList.add('disabled');
            if (this.loader) this.loader.classList.remove('hidden');
            if (typeof toggleLoader === 'function') toggleLoader(true);
            this.showButton = true;

            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = text;

                const columns = tempDiv.querySelectorAll('[data-render-columns]');
                const paginationWrapper = document.querySelector('[data-paging-loader-parent]');
                const newPagination = tempDiv.querySelector('[data-paging-loader-parent]');
                const parentNode = paginationWrapper.parentNode;

                columns.forEach((column) => {
                  parentNode.insertBefore(column, paginationWrapper);
                  const atcBtn = column.querySelector('atc-submit-form');
                  if (atcBtn) atcBtn.initialize();
                  const variantChanger = column.querySelector('single-variant');
                  if (variantChanger) variantChanger.initialize();
                });

                if (newPagination) {
                  paginationWrapper.innerHTML = newPagination.innerHTML;
                } else {
                  this.showButton = false;
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                if (!this.showButton) {
                  const parent = this.parentElement;
                  parent.style.display = 'none';
                } else {
                  this.button.classList.remove('disabled');
                  if (this.loader) this.loader.classList.add('hidden');
                }

                if (typeof toggleLoader === 'function') toggleLoader(false);
              });
          };

          const hideButton = () => {
            const parent = this.parentElement;
            parent.style.display = 'none';
          };
          initialize();
        }
      }
    );
  }
  class FacetRemoveButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      const onClick = (event) => {
        event.preventDefault();
        switch (this.dataset.name) {
          case 'all':
            setFilterParam(null, null, 'all');
            break;
          default:
            setFilterParam(this.dataset.name, this.dataset.value, true);
            break;
        }
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
      };
      this.button.addEventListener('click', onClick.bind(this));
    }
  }
  if (!customElements.get('facet-remove-button')) customElements.define('facet-remove-button', FacetRemoveButton);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.anchor = this.querySelector('a');
      this.anchor.addEventListener('click', this.onClickRef.bind(this));
    }
    
    onClickRef(){
      event.preventDefault();
      const targetId = this.anchor.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      if(targetElement){
        if(this.dataset.offset){
          let offset = 0;
          const offsetElement = document.querySelector(this.dataset.offset);
          if(!offsetElement){
            doScroll();
            if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return
          };
          const elementPosition = targetElement.getBoundingClientRect().top;
          offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
          window.scrollTo({
            top: offset,
            behavior: "smooth"
          });
          if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
          return;
        }
        doScroll();
        if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
      }
      function doScroll(){
        targetElement.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  }
  if(!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reset-password"]) return;
  try {
    
  class SmoothAnchor extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.anchor = this.querySelector('a');
      this.anchor.addEventListener('click', this.onClickRef.bind(this));
    }
    
    onClickRef(){
      event.preventDefault();
      const targetId = this.anchor.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      if(targetElement){
        if(this.dataset.offset){
          let offset = 0;
          const offsetElement = document.querySelector(this.dataset.offset);
          if(!offsetElement){
            doScroll();
            if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
            return
          };
          const elementPosition = targetElement.getBoundingClientRect().top;
          offset = elementPosition + window.scrollY - offsetElement.offsetHeight;
          window.scrollTo({
            top: offset,
            behavior: "smooth"
          });
          if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
          return;
        }
        doScroll();
        if(targetElement.nodeName.toLowerCase() === 'input') targetElement.focus();
      }
      function doScroll(){
        targetElement.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  }
  if(!customElements.get('smooth-anchor')) customElements.define('smooth-anchor', SmoothAnchor);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      ) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if(!loader) return;
    if(state){
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease'
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease'
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => arr.push(document.querySelector(selector)));
    return arr;
  };
  const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem.querySelectorAll('[data-update-link]');
    if(!links || links.length === 0) return;
    links.forEach(link => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    this.currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    setStatuses(this.currentVariant, formsSelector, renders, parentSelector);
    if(!this.currentVariant) return;
    if(this.currentVariant.featured_image) setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    updateLinks(this.currentVariant.id, parentSelector);
    renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector);
  };
  const changeText = (element, text) => {
    for (const node of element.childNodes) {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = text;
        break;
      }
    }
  }
  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = form.querySelector('[name="add"]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      if(variant.available){
        changeText(atcBtn, atcBtn.dataset.textAvail);
        atcBtn.removeAttribute('disabled');
        return;
      }
      changeText(atcBtn, atcBtn.dataset.textSold);
      atcBtn.setAttribute('disabled', '');
    });
  };
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
      const imageContainer = document.querySelector(arr[0]);
      var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
      var newOpacity = (currentOpacity === 1) ? 0 : 1;
      imageContainer.style.transition = 'opacity 0.3s ease';
      imageContainer.style.opacity = newOpacity;
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        setTimeout(() => {
          imageContainer.style.opacity = 1;
        }, 0);
      }, 500);
      return
    }
    arr.forEach(gallery => {
      const gal = document.querySelector(gallery);
      if(!gal) return;
      switch(gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
          if(activeIndex === -1 || activeIndex === items[activeIndex]) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          let slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          if(slide[0]) return splide.go(slide[0].index);
          gal.querySelector(`[data-media-id="${imageId}"]`)?.scrollIntoView({behavior:'smooth',block:'center',inline:'center'});
          break;
      }
    });
  };
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector) => {
    toggleLoader(true);
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const parentElement = document.querySelector(parent);
        const arr = JSON.parse(elems);
        arr.forEach(selector => {
          const element = parentElement.querySelector(selector);
          if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
        });
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
        toggleLoader(false);
      }
    );
  };
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const element = parentElem.querySelector(selector);
      if(!element) return;
      flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
    });
    if(!btn) return;
    changeText(btn, btn.dataset.textUnavail);
    btn.setAttribute('disabled', '');
  };
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const html = new DOMParser() .parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    toggleLoader(true);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        toggleLoader(false);
        if(!this.error){
          if(element.dataset.selfModal){
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      }
    );
  }
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  const setFilterParam = (param, value, remove = false, getParams = false) => {
    const input = document.getElementById('filters-params');
    const url = new URL(input.value, window.location.origin);
    if(getParams){
      const params = new URLSearchParams(url.searchParams).toString();
      return params;
    }
    switch(remove){
      case true:
        if(param.includes('price')){
          [...url.searchParams.keys()].forEach(key => key.includes('filter.v.price') && url.searchParams.delete(key));
        } else{
          const valToDel = value;
          const values = url.searchParams.getAll(param);
          const updatedValues = values.filter(value => value !== valToDel);
          url.searchParams.delete(param);
          updatedValues.forEach(value => url.searchParams.append(param, value));
        }
        break;
      case 'all':
        [...url.searchParams.keys()].forEach(key => key.includes('filter') && url.searchParams.delete(key));
        break;
      default:
        if(param.includes('price')){
          url.searchParams.set(param, value);
        } else{
          url.searchParams.append(param, value);
        }
        break;
    }
    input.value = url.toString();
  }
  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if ((this.dataset.desktopHidden && window.screen.width > 991) || (this.dataset.mobileHidden && window.screen.width < 768)) return;
      this.button = this.querySelector('button');
      if(!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }
      const toggleModal = (event) => {
        event.preventDefault();
        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      }
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if(!customElements.get('modal-component-toggler')) customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalFilterComponent extends HTMLElement {
    constructor() {
      super();
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
    }
    open(toggler = null){
      this.toggler = toggler;
      this.parent = this.parentElement;
      document.body.append(this);
      this.renderModal();
    }
    doAnimate(){
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }
    renderModal(){
      toggleLoader(true);
      const sectionId = document.getElementById('modal-section').value;
      const modalParams = document.querySelector('#filters-params');
      fetch(modalParams.value + sectionId)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html').querySelector(`#${this.dataset.renderSelector}`);
          const parent = this.querySelector(this.dataset.selector);
          parent.innerHTML = html.innerHTML;
        })
        .catch((e) => {
          console.error(e);
          throw e;
        })
        .finally(() => {
          this.setClasses(true);
          this.doAnimate();
          trapFocus(this.content);
          this.initFilters();
          this.setListeners(true);
          toggleLoader(false);
        }
      );
    }
    initFilters(){
      trapFocus(this.content);
      this.setListeners(true);
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
      setTimeout(() => {
        this.classList.add('--rendered');
      }, 500);
      this.fields = this.querySelectorAll('input');
      this.fields.forEach(field => {
        field.addEventListener('input', this.debouncedOnSubmit.bind(this));
      });
    }
    onSubmitHandler(event){
      event.preventDefault();
      const target = event.target;
      switch(target.type){
        case 'checkbox':
          setFilterParam(target.name, target.value, !target.checked);
          break;
        case 'number':
          setFilterParam(target.name, target.value);
          break;
        default:
          console.log('other any');
          break;
      }
      const facetsFilter = document.querySelector('facets-filter');
      facetsFilter.onSubmitHandler(target.id);
    }
    close() {
      this.fields.forEach(field => {
        field.removeEventListener('input', this.onSubmitHandler.bind(this));
      });
      setTimeout(() => {
        this.classList.add('--rendered');
      }, 500);
      if(this.dataset.trigger !== 'self'){
        document.body.removeChild(this);
        if(this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if(this.toggler){
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag){
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    setListeners(flag){
      if(this.dataset.hideOutside === 'false') return;
      switch(flag){
        case true:
          this.addEventListener('keyup', this.onKeyUp);
          this.addEventListener('click', this.onBodyClick);
          break;
        default:
          this.removeEventListener('keyup', this.onKeyUp);
          this.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onBodyClick(event){
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if(boundings.contains(target) || target === boundings) return;
      this.close();
    }
    onKeyUp(event){
      if(event.key === 'Escape') this.close();
    }
  }
  if(!customElements.get('modal-filter-component')) customElements.define('modal-filter-component', ModalFilterComponent);
  class FacetsFilter extends HTMLElement {
    constructor() {
      super();

      this.cachedResults = [];
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    connectedCallback(){
      this.initParams = setFilterParam(null, null, false, true);
    }

    onHistoryChange(event){
      if(event.state && this.cachedResults.length === 0){
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
        return;
      }
      
      if(this.cachedResults && this.cachedResults.length > 0){
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = {params: searchParams};
        if (this.cachedResults.some(key => key.params === term.params)) return this.renderFromCache(this.cachedResults, term, false);
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
      }
    }

    onSubmitHandler(target){
      toggleLoader(true);
      const input = document.querySelector('#filters-params');
      let inputValue = input.value;
      if(!inputValue.includes('?')) inputValue = input.value + '?';
      const sectionsInput = document.querySelector('#filters-sections');
      const url = inputValue + sectionsInput.value;
      const searchParams = setFilterParam(null, null, false, true);
      const term = {params: searchParams};
      if(this.cachedResults.length > 0 && this.cachedResults.some(key => key.params === term.params)){
        this.renderFromCache(this.cachedResults, term, true, target);
        return;
      }
      this.renderFetch(url, true, searchParams, target);
    }

    renderFetch(url, updateURLHash = false, searchParams, target = null){
      fetch(url)
        .then(response => response.json())
        .then((data) => {
          const secArr = JSON.parse(this.dataset.sections);
          secArr.forEach(section => {
            const html = new DOMParser() .parseFromString(data[section.id], 'text/html').getElementById(section.id);
            section.selectors.forEach(selector => {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.outerHTML = sourceElement.outerHTML;
              }
            });
          });
          const cacheObj = {params: searchParams, content: data};
          this.cachedResults.push(cacheObj);
        })
        .catch((e) => {
          console.log(e);
          throw e;
        })
        .finally(() => {
          if(updateURLHash) this.updateURLHash(searchParams);
          const modal = document.querySelector('modal-filter-component.modal--active');
          if(modal) modal.initFilters();
          if(target){
            const org = document.getElementById(target);
            if(org) org.focus();
          }
          toggleLoader(false);
        }
      );
    }

    renderFromCache(cache, filter, updateURLHash = false, target = null){
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find(results => results.params === filter.params);
      const secArr = JSON.parse(this.dataset.sections);
      secArr.forEach(section => {
        const html = new DOMParser() .parseFromString(cachedResults.content[section.id], 'text/html').getElementById(section.id);
        section.selectors.forEach(selector => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.outerHTML = sourceElement.outerHTML;
          }
        });
      });
      if(updateURLHash) this.updateURLHash(filter.params);
      const modal = document.querySelector('modal-filter-component.modal--active');
      if(modal) modal.initFilters();
      if(target){
        const org = document.getElementById(target);
        if(org) org.focus();
      }
      toggleLoader(false);
    }

    updateURLHash(searchParams){
      const updatedSearchParams = setFilterParam(null, null, false, true);
      history.pushState({ searchParams }, '', `${window.location.pathname}${updatedSearchParams && '?'.concat(updatedSearchParams)}`);
    }
  }
  if(!customElements.get('facets-filter')) customElements.define('facets-filter', FacetsFilter);
  class DropdownComponent extends HTMLElement {
    constructor() {
      super();
      if(this.dataset.desktopHidden === 'true' && window.screen.width > 767) return;
      if(this.dataset.desktopHidden === 'wide' && window.screen.width > 991) return;
      this.button = this.querySelector('.dropdown-component_opener');
      this.content = this.querySelector('.dropdown-component_wrapper');
      if(!this.button || !this.content) return;
      this.onButtonClick = this.toggleDropdown.bind(this);
      this.onButtonClose = this.close.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.button.addEventListener('click', this.onButtonClick);
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if(this.closeButton) this.closeButton.addEventListener('click', this.onButtonClose);
      if(this.dataset.onHover === 'true' && window.screen.width > 1025){
        this.addEventListener('mouseenter', this.onButtonClick);
        this.addEventListener('mouseleave', this.onButtonClose);
      }
    }

    open(){
      this.button.setAttribute('aria-expanded', true);
      this.content.classList.add('dropdown--open');
      this.content.focus();
      trapFocus(this.content);
      document.body.addEventListener('click', this.onBodyClick);
      this.addEventListener('keyup', this.onKeyUp);
    }

    close(){
      this.button.setAttribute('aria-expanded', false);
      this.content.classList.remove('dropdown--open');
      trapFocus(null, this.content, false);
      document.body.removeEventListener('click', this.onBodyClick);
      this.removeEventListener('keyup', this.onKeyUp);
    }

    toggleDropdown(event){
      if(event.target.getAttribute('aria-expanded') === 'true') return this.close();
      this.open();
    }

    onBodyClick(event){
      const target = event.target;
      if(this.contains(target) || target === this || target === this.button
        && this.button.getAttribute('aria-expanded') === 'true') return;
      this.doClose(event);
    }

    onKeyUp(event){
      if(event.key !== 'Escape') return;
      this.doClose(event);
    }

    doClose(event){
      if(this.dataset.level === '2'){
        event.stopPropagation();
        this.close();
        this.button.focus();
        const parentDropdown = this.closest('dropdown-component[data-level="1"]');
        if(parentDropdown && parentDropdown.content) trapFocus(parentDropdown.content);
        return;
      }
      this.close();
      this.button.focus();
    }
  }
  if(!customElements.get('dropdown-component')) customElements.define('dropdown-component', DropdownComponent);
  class SortDropdown extends DropdownComponent {
    constructor() {
      super();

      this.items = this.content.querySelectorAll('[data-btn-sort]');
      if(!this.items) return;
    }

    connectedCallback(){
      const setCurrentValue = (target) => {
        const elem = this.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setFilterParam('sort_by', target.dataset.value);
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
        this.close();
      }

      const onSortSelect = (event) => {
        const target = event.target;
        this.items.forEach(item => item.classList.remove('active'));
        target.classList.add('active');
        setCurrentValue(target);
      }
      this.sortSelect = onSortSelect.bind(this);
    }

    open(){
      this.items.forEach(item => {item.addEventListener('click', this.sortSelect);});
      super.open();
    }

    close(){
      this.items.forEach(item => {item.removeEventListener('click', this.sortSelect);});
      super.close();
    }
  }
  if(!customElements.get('sort-dropdown')) customElements.define('sort-dropdown', SortDropdown);
  class VariantDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content.querySelectorAll('[data-btn-variant]');
      if (!this.button || !this.content || !this.items) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback(){
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const select = (event) => {
        event.preventDefault();
        const form = document.getElementById(self.dataset.formId);
        const input = self.querySelector('[data-submit-input]');
        if (!input || !form) return;
        input.value = event.currentTarget.dataset.value;
        form.submit();
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        self.items.forEach(item => {item.addEventListener('click', self.variantSelect);});
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
      };
      const closeDropdown = () => {
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        trapFocus(null, self.button, false);
        self.items.forEach(item => {item.removeEventListener('click', self.variantSelect);});
        document.body.removeEventListener('click', onBodyClick);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          target === self.button && self.button.getAttribute('aria-expanded') === 'true'
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        closeDropdown();
      };
      const setVariantOptions = (value) => {
        const parent = document.querySelector(this.dataset.parent);
        const errElem = document.querySelector(this.dataset.errorSelector);
        const selElem = document.querySelector(this.dataset.selectedParent);
        if(!parent) return;
        if(errElem) errElem.classList.add('hidden');
        if(selElem) selElem.innerText = value;
        const currentSet = JSON.parse(this.dataset.currentSet);
        const index = parseInt(this.dataset.optionIndex);
        currentSet[index] = value;
        const pills = parent.querySelectorAll('variant-pill, variant-dropdown');
        pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
        setOptions(pills, currentSet);
        let availableSet = null;
        if(this.dataset.checkSets === 'true'){
          const sets = JSON.parse(this.dataset.availableSets);
          const checkSet = (val) => {
            if (!val || !Array.isArray(sets)) return null;
            return sets.find(set => set.includes(val));
          };
          availableSet = checkSet(value);
        }
        onVariantChange(this.dataset.jsonSelector, availableSet ? availableSet : currentSet, this.dataset.forms, this.dataset.renders, this.dataset.mainParent, this.dataset.galleries, this.dataset.sectionId, this.dataset.productUrl, this.dataset.updateUrl, this.dataset.focusSelector ? this.dataset.focusSelector : null, this.dataset.mediaTemplate === 'true' ? true : false, this.dataset.mediaTemplate === 'true' ? this.dataset.template : null);
      };
      const setOptions = (elems, set) => {
        const json = document.querySelector(this.dataset.jsonSelector);
        const data = JSON.parse(json.textContent);
        const variants = data.variants;
        const selectedOptionOneVariants = variants.filter(variant => set[0] === variant.option1);
        elems.forEach((select, index) => {
          if (index === 0) return;
          const optionInputs = [...select.querySelectorAll('[data-btn-variant]')];
          const previousOptionSelected = elems[index - 1].querySelector('[data-btn-variant].product-card_select-option--active').dataset.value;
          const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
          setAvailability(optionInputs, availableOptionInputsValue);
        });
      }
      const setAvailability = (listOfOptions, listOfAvailableOptions) => {
        listOfOptions.forEach(elem => {
          const labelText = elem.querySelector('[data-variant-status-text]');
          if (listOfAvailableOptions.includes(elem.getAttribute('data-value'))){
            labelText.classList.add('hidden');
            return;
          }
          labelText.classList.remove('hidden');
        });
      }
      const setCurrentValue = (target) => {
        const elem = self.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setVariantOptions(target.dataset.value);
        closeDropdown();
      }
      const onVariantSelect = (event) => {
        const target = event.target;
        self.items.forEach(item => item.classList.remove('product-card_select-option--active'));
        target.classList.add('product-card_select-option--active');
        setCurrentValue(target);
      }
      this.variantSelect = onVariantSelect;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('variant-dropdown')) { customElements.define('variant-dropdown', VariantDropdown); }
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onAddToCart = (event) => {
        event.preventDefault();
        this.error = false;
        this.recipientForm = this.form.querySelector('recipient-form');
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetchAtc(secArr, config, this);
      };
      this.submit = onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);
  if (!customElements.get('grid-load-more')) {
    customElements.define('grid-load-more', class GridLoadMore extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
      }

      connectedCallback() {
        if (!this.button) return;

        const initialize = () => {
          if (this.dataset.infinite === 'true') this.requested = false;
          setListeners();
        };

        const setListeners = () => {
          const loadMore = onLoadMore.bind(this);
          this.button.addEventListener('click', loadMore);

          if (this.dataset.infinite === 'true') {
            window.addEventListener('scroll', loadInfinite.bind(this));
          }
        };

        const loadInfinite = () => {
          const handleObserver = (entries, observer) => {
            observer.unobserve(this);
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                if (this.requested) return;
                this.button.dispatchEvent(new Event('click'));
                this.requested = true;
              } else {
                this.requested = false;
              }
            });
          };

          new IntersectionObserver(handleObserver, { rootMargin: '0px 0px -60px 0px' }).observe(this);
        };

        const onLoadMore = (event) => {
          event.preventDefault();
          this.button.classList.add('disabled');
          if (this.loader) this.loader.classList.remove('hidden');
          if (typeof toggleLoader === 'function') toggleLoader(true);
          this.showButton = true;

          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = text;

              const columns = tempDiv.querySelectorAll('[data-render-columns]');
              const paginationWrapper = document.querySelector('[data-paging-loader-parent]');
              const newPagination = tempDiv.querySelector('[data-paging-loader-parent]');
              const parentNode = paginationWrapper.parentNode;

              columns.forEach(column => {
                parentNode.insertBefore(column, paginationWrapper);
                const atcBtn = column.querySelector('atc-submit-form');
                if (atcBtn) atcBtn.initialize();
                const variantChanger = column.querySelector('single-variant');
                if (variantChanger) variantChanger.initialize();
              });

              if (newPagination) {
                paginationWrapper.innerHTML = newPagination.innerHTML;
              } else {
                this.showButton = false;
              }
            })
            .catch(e => {
              console.error(e);
            })
            .finally(() => {
              if (!this.showButton) {
                const parent = this.parentElement;
                parent.style.display = 'none';
              } else {
                this.button.classList.remove('disabled');
                if (this.loader) this.loader.classList.add('hidden');
              }

              if (typeof toggleLoader === 'function') toggleLoader(false);
            });
        };

        const hideButton = () => {
          const parent = this.parentElement;
          parent.style.display = 'none';
        };
        initialize();
      }
    });
  }
  class FacetRemoveButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.button = this.querySelector('button');
      if(!this.button) return;

      const onClick = (event) => {
        event.preventDefault();
        switch (this.dataset.name) {
          case 'all':
            setFilterParam(null, null, 'all')
            break;
          default:
            setFilterParam(this.dataset.name, this.dataset.value, true);
            break;
        }
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
      }
      this.button.addEventListener('click', onClick.bind(this));
    }
  }
  if(!customElements.get('facet-remove-button')) customElements.define('facet-remove-button', FacetRemoveButton);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-text"] && !Shopify.designMode) return;
  try {
    
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[data-id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this._lc.bind(this));
    }
    connectedCallback() {
      if (this.dataset.playViewport === 'true') {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const poster = this.querySelector('[data-id^="Deferred-Poster-"]');
              if (poster) poster.click();
              const video = this.querySelector('video');
              if (video) video.play();
              const parent = document.querySelector(this.dataset.parent);
              if(parent) parent.classList.add('video-playing');
              observer.unobserve(this);
            }
          });
        }, { threshold: 1.0 });
        observer.observe(this);
      }
      if (this.dataset.onHover === 'true') {
        this.addEventListener('focusin', this._handleFocus.bind(this), true);
        this.addEventListener('mouseenter', this._handleFocus.bind(this));
      }
      const poster = this.querySelector('[data-id^="Deferred-Poster-"]');
      if (poster && this.dataset.onHover === 'true'){
        poster.setAttribute('tabindex', '0');
        this.addEventListener('keydown', (e) => {
          const poster = this.querySelector('[data-id^="Deferred-Poster-"]');
          if ((e.key === 'Enter' || e.key === ' ') && document.activeElement === poster) {
            e.preventDefault();
            poster.click();
          }
        });
      }
    }
    _handleFocus() {
      if (!this.getAttribute('loaded')) {
        const poster = this.querySelector('[data-id^="Deferred-Poster-"]');
        if (poster) poster.click();
        requestAnimationFrame(() => {
          const video = this.querySelector('video');
          if (video) video.play().catch(() => {});
        });
      } else {
        const video = this.querySelector('video');
        if (video) video.play().catch(() => {});
      }
    }
    _lc(focus = true) {
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus && deferredElement instanceof HTMLElement) deferredElement.focus();
        if (deferredElement.nodeName === 'VIDEO' && deferredElement.getAttribute('autoplay')) deferredElement.play().catch(() => {});
        if (!this.dataset.sectionId) return;
        const section = document.getElementById(this.dataset.sectionId);
        if (section) section.classList.add('--remove-sliders');
      }
    }
  }
  if (!customElements.get('deferred-media')) customElements.define('deferred-media', DeferredMedia);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      ) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
  };
  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      
      if ((this.dataset.desktopHidden && window.screen.width > 991) || (this.dataset.mobileHidden && window.screen.width < 768)) return;
      this.button = this.querySelector('button');
      if(!this.button) return;

      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }

      const toggleModal = (event) => {
        event.preventDefault();
        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      }
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if(!customElements.get('modal-component-toggler')) customElements.define('modal-component-toggler', ModalComponentToggler);

  class ModalComponentNewsletterPopup extends HTMLElement {
    constructor() {
      super();
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.initPopupBehavior();
    }
    initPopupBehavior() {
      const storageKey = this.dataset.storageKey;
      const storageValue = this.dataset.storageValue || null;
      if (storageKey && localStorage.getItem(storageKey) === storageValue) {
        this.remove();
        return;
      }
      if (!window.location.href.includes('challenge') || !this.classList.contains('modal--active')) {
        if (this.dataset.trigger === 'self') {
          this.open();
          return;
        }
        this.onScroll = this.showOnScroll.bind(this);
        this.delay = parseInt(this.dataset.delay || "0", 10);
        window.addEventListener('scroll', this.onScroll);
      }
    }
    showOnScroll() {
      if (window.scrollY > this.delay) {
        window.removeEventListener('scroll', this.onScroll);
        this.open();
      }
    }
    doAnimate(){
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }
    open(toggler = null){
      this.toggler = toggler;
      this.parent = this.parentElement;
      if(this.dataset.trigger !== 'self') document.body.append(this);
      this.setClasses(true);
      this.doAnimate();
      trapFocus(this.content);
      this.setListeners(true);
    }
    close(){
      if(this.dataset.trigger !== 'self'){
        document.body.removeChild(this);
        if(this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if(this.toggler){
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag){
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    setListeners(flag){
      if(this.dataset.hideOutside === 'false') return;
      switch(flag){
        case true:
          this.addEventListener('keyup', this.onKeyUp);
          this.addEventListener('click', this.onBodyClick);
          break;
        default:
          this.removeEventListener('keyup', this.onKeyUp);
          this.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onKeyUp(event){
      if(event.key === 'Escape') this.close();
    }
    onBodyClick(event){
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if(boundings.contains(target) || target === boundings) return;
      this.close();
    }
  }
  if(!customElements.get('modal-component-newsletter-popup')) customElements.define('modal-component-newsletter-popup', ModalComponentNewsletterPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["overlaps-images"] && !Shopify.designMode) return;
  try {
    
  class SectionScaler extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const vh = window.innerHeight;
      const totalSlides = parseInt(this.dataset.totalInners, 10);
      let currentValue = 0;
      let targetValue = 0;
      let rafId = null;
      const updateInertia = () => {
        currentValue += (targetValue - currentValue) * 0.05; // smoothness here by reducing the value
        this.style.setProperty('--animate-value', currentValue.toFixed(3));
        rafId = requestAnimationFrame(updateInertia);
      };
      const handleScroll = () => {
        const sectionTop = this.offsetTop;
        const scrolledInSection = window.scrollY - sectionTop;
        let section = scrolledInSection / vh;
        section = Math.max(0, Math.min(section, totalSlides));
        targetValue = section;
      };
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              window.addEventListener("scroll", handleScroll, { passive: true });
              if (!rafId) rafId = requestAnimationFrame(updateInertia);
            } else {
              window.removeEventListener("scroll", handleScroll);
              if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = null;
              }
            }
          });
        },
        {
          root: null,
          rootMargin: `-10% 0px 0px 0px`,
          threshold: 0,
        }
      );
      this.observer.observe(this);
    }
  }
  if (!customElements.get("section-scaler")) { customElements.define("section-scaler", SectionScaler); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendation"]) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      ) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if(!loader) return;
    if(state){
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease'
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease'
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const getJsonParse = (attrStr) => {
    let arr = [];
    const strArr = attrStr ? JSON.parse(attrStr) : null;
    if(!strArr) return arr = null;
    strArr.forEach(selector => arr.push(document.querySelector(selector)));
    return arr;
  };
  const updateLinks = (variant, parent) => {
    const parentElem = document.querySelector(parent);
    const links = parentElem.querySelectorAll('[data-update-link]');
    if(!links || links.length === 0) return;
    links.forEach(link => {
      const url = new URL(link.href);
      url.searchParams.set('variant', variant);
      link.href = url.toString();
    });
  };
  const onVariantChange = (jsonSelector, optSet, formsSelector, renders, parentSelector, gallerySelectors, sectionId, productUrl, updateUrl, focusSelector, renderMedia, templateSelector) => {
    const json = document.querySelector(jsonSelector);
    if(!json) return;
    const data = JSON.parse(json.textContent);
    const variants = data.variants;
    this.currentVariant = variants.find(variant => variant.options.every((option, index) => option === optSet[index]));
    setStatuses(this.currentVariant, formsSelector, renders, parentSelector);
    if(!this.currentVariant) return;
    if(this.currentVariant.featured_image) setGallery(this.currentVariant.featured_image, gallerySelectors, renderMedia, templateSelector);
    updateLinks(this.currentVariant.id, parentSelector);
    renderVariant(renders, this.currentVariant.id, parentSelector, productUrl, sectionId, updateUrl, focusSelector);
  };
  const changeText = (element, text) => {
    for (const node of element.childNodes) {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = text;
        break;
      }
    }
  }
  const setStatuses = (variant, formElems, renderElems, parentElem) => {
    const forms = getJsonParse(formElems);
    forms.forEach(form => {
      if(!form) return;
      const atcBtn = form.querySelector('[name="add"]');
      if(!variant) return toggleAvail(false, renderElems, parentElem, atcBtn);
      toggleAvail(true, renderElems, parentElem);
      const input = form.querySelector('[name="id"]');
      input.value = variant.id;
      if(!atcBtn) return;
      if(variant.available){
        changeText(atcBtn, atcBtn.dataset.textAvail);
        atcBtn.removeAttribute('disabled');
        return;
      }
      changeText(atcBtn, atcBtn.dataset.textSold);
      atcBtn.setAttribute('disabled', '');
    });
  };
  const setGallery = (imageId, galleries, render, template) => {
    const arr = JSON.parse(galleries);
    if(render){
      const templateElem = document.querySelector(template);
      const templateElement = templateElem.content.querySelector(`[data-media-id="${imageId}"]`);
      const imageContainer = document.querySelector(arr[0]);
      var currentOpacity = parseFloat(imageContainer.style.opacity) || 1;
      var newOpacity = (currentOpacity === 1) ? 0 : 1;
      imageContainer.style.transition = 'opacity 0.3s ease';
      imageContainer.style.opacity = newOpacity;
      setTimeout(() => {
        imageContainer.innerHTML = templateElement.outerHTML;
        setTimeout(() => {
          imageContainer.style.opacity = 1;
        }, 0);
      }, 500);
      return
    }
    arr.forEach(gallery => {
      const gal = document.querySelector(gallery);
      if(!gal) return;
      switch(gal.slider) {
        case undefined:
          let items = Array.from(gal.querySelectorAll('[data-gal-item]'));
          const activeIndex = items.findIndex(item => item.dataset.mediaId == imageId);
          if(activeIndex === -1 || activeIndex === items[activeIndex]) return;
          items.unshift(items.splice(activeIndex, 1)[0]);
          gal.innerHTML = '';
          gal.classList.add('--swapped');
          gal.append(...items);
          break;
        default:
          const splide = gal.slider;
          let slide = splide.Components.Slides.filter(`[data-media-id="${imageId}"]`);
          if(slide[0]) return splide.go(slide[0].index);
          gal.querySelector(`[data-media-id="${imageId}"]`)?.scrollIntoView({behavior:'smooth',block:'center',inline:'center'});
          break;
      }
    });
  };
  const renderVariant = (elems, id, parent, url, section, updateUrl, focusSelector) => {
    toggleLoader(true);
    fetch(`${url}?variant=${id}&section_id=${section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const parentElement = document.querySelector(parent);
        const arr = JSON.parse(elems);
        arr.forEach(selector => {
          const element = parentElement.querySelector(selector);
          if (element && html.querySelector(selector)) element.innerHTML = html.querySelector(selector).innerHTML;
        });
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if(updateUrl === 'true') window.history.replaceState({ }, '', `${url}?variant=${id}`);
        if(focusSelector){
          const focusParent = document.querySelector(focusSelector);
          trapFocus(focusParent.content ? focusParent.content : focusParent);
        }
        toggleLoader(false);
      }
    );
  };
  const toggleAvail = (flag, selectors, parent, btn) => {
    const arr = JSON.parse(selectors);
    const parentElem = document.querySelector(parent);
    arr.forEach(selector => {
      const element = parentElem.querySelector(selector);
      if(!element) return;
      flag ? element.classList.remove('--elem-opac') : element.classList.add('--elem-opac');
    });
    if(!btn) return;
    changeText(btn, btn.dataset.textUnavail);
    btn.setAttribute('disabled', '');
  };
  const sectionArrRender = (secArr, response) => {
    secArr.forEach(section => {
      const html = new DOMParser() .parseFromString(response.sections[section.id], 'text/html').getElementById(section.id);
      section.selectors.forEach(selector => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.outerHTML = sourceElement.outerHTML;
        }
      });
    });
  };
  const resetQty = (elem) => {
    const form = document.querySelector(elem);
    if(!form) return;
    const qtyField = form.quantity;
    qtyField.value = parseFloat(qtyField.min);
    qtyField.dispatchEvent(new Event('input'));
  };
  const atcError = (response, elem, flag) => {
    const errElem = document.querySelector(elem.dataset.errorSelector);
    const errSpan = errElem.querySelector('[data-error]');
    const recepForm = elem.form.querySelector('recipient-form');
    if(!flag){
      errElem.classList.add('hidden');
      errSpan.innerText = '';
      if(recepForm) recepForm.clearErrorMessage();
      return;
    }
    if(recepForm && response.errors) recepForm.displayErrorMessage(null, response.errors);
    if(typeof response.description !== 'object'){
      errElem.classList.remove('hidden');
      errSpan.innerText = response.description;
    }
    resetQty(elem.dataset.form);
  };
  const fetchAtc = (sections, config, element) => {
    this.error = true;
    toggleLoader(true);
    atcError(null, element, false);
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if(!response.sections) return atcError(response, element, true);
        this.error = false;
        sectionArrRender(sections, response);
      })
      .catch((e) => {
        console.log(e);
        throw e;
      })
      .finally(() => {
        resetQty(element.dataset.form);
        toggleLoader(false);
        if(!this.error){
          if(element.dataset.selfModal){
            const toggler = document.querySelector('modal-render-component.modal--active button[data-modal-ref]');
            toggler.dispatchEvent(new Event('click'));
          }
          if(element.dataset.redirect) return window.location.href = element.dataset.redirect;
          if(element.dataset.modal === 'true'){
            const drawerToggler = document.querySelector(element.dataset.modalRef);
            if(drawerToggler) drawerToggler.dispatchEvent(new Event('click'));
          }
          if (element.recipientForm) {
            element.recipientForm.resetRecipientForm();
          }
        }
      }
    );
  }
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  class VariantDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content.querySelectorAll('[data-btn-variant]');
      if (!this.button || !this.content || !this.items) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback(){
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const select = (event) => {
        event.preventDefault();
        const form = document.getElementById(self.dataset.formId);
        const input = self.querySelector('[data-submit-input]');
        if (!input || !form) return;
        input.value = event.currentTarget.dataset.value;
        form.submit();
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        self.items.forEach(item => {item.addEventListener('click', self.variantSelect);});
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
      };
      const closeDropdown = () => {
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        trapFocus(null, self.button, false);
        self.items.forEach(item => {item.removeEventListener('click', self.variantSelect);});
        document.body.removeEventListener('click', onBodyClick);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          target === self.button && self.button.getAttribute('aria-expanded') === 'true'
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        closeDropdown();
      };
      const setVariantOptions = (value) => {
        const parent = document.querySelector(this.dataset.parent);
        const errElem = document.querySelector(this.dataset.errorSelector);
        const selElem = document.querySelector(this.dataset.selectedParent);
        if(!parent) return;
        if(errElem) errElem.classList.add('hidden');
        if(selElem) selElem.innerText = value;
        const currentSet = JSON.parse(this.dataset.currentSet);
        const index = parseInt(this.dataset.optionIndex);
        currentSet[index] = value;
        const pills = parent.querySelectorAll('variant-pill, variant-dropdown');
        pills.forEach(pill => pill.setAttribute('data-current-set', JSON.stringify(currentSet)));
        setOptions(pills, currentSet);
        let availableSet = null;
        if(this.dataset.checkSets === 'true'){
          const sets = JSON.parse(this.dataset.availableSets);
          const checkSet = (val) => {
            if (!val || !Array.isArray(sets)) return null;
            return sets.find(set => set.includes(val));
          };
          availableSet = checkSet(value);
        }
        onVariantChange(this.dataset.jsonSelector, availableSet ? availableSet : currentSet, this.dataset.forms, this.dataset.renders, this.dataset.mainParent, this.dataset.galleries, this.dataset.sectionId, this.dataset.productUrl, this.dataset.updateUrl, this.dataset.focusSelector ? this.dataset.focusSelector : null, this.dataset.mediaTemplate === 'true' ? true : false, this.dataset.mediaTemplate === 'true' ? this.dataset.template : null);
      };
      const setOptions = (elems, set) => {
        const json = document.querySelector(this.dataset.jsonSelector);
        const data = JSON.parse(json.textContent);
        const variants = data.variants;
        const selectedOptionOneVariants = variants.filter(variant => set[0] === variant.option1);
        elems.forEach((select, index) => {
          if (index === 0) return;
          const optionInputs = [...select.querySelectorAll('[data-btn-variant]')];
          const previousOptionSelected = elems[index - 1].querySelector('[data-btn-variant].product-card_select-option--active').dataset.value;
          const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
          setAvailability(optionInputs, availableOptionInputsValue);
        });
      }
      const setAvailability = (listOfOptions, listOfAvailableOptions) => {
        listOfOptions.forEach(elem => {
          const labelText = elem.querySelector('[data-variant-status-text]');
          if (listOfAvailableOptions.includes(elem.getAttribute('data-value'))){
            labelText.classList.add('hidden');
            return;
          }
          labelText.classList.remove('hidden');
        });
      }
      const setCurrentValue = (target) => {
        const elem = self.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setVariantOptions(target.dataset.value);
        closeDropdown();
      }
      const onVariantSelect = (event) => {
        const target = event.target;
        self.items.forEach(item => item.classList.remove('product-card_select-option--active'));
        target.classList.add('product-card_select-option--active');
        setCurrentValue(target);
      }
      this.variantSelect = onVariantSelect;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('variant-dropdown')) { customElements.define('variant-dropdown', VariantDropdown); }
  class AtcSubmit extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback(){
      this.form = document.querySelector(this.dataset.form);
      if(!this.form) return;
      const onAddToCart = (event) => {
        event.preventDefault();
        this.error = false;
        this.recipientForm = this.form.querySelector('recipient-form');
        const secArr = JSON.parse(this.dataset.sections);
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        formData.append('sections', secArr.map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetchAtc(secArr, config, this);
      };
      this.submit = onAddToCart.bind(this);
      this.form.addEventListener('submit', this.submit);
    }
  }
  if(!customElements.get('atc-submit')) customElements.define('atc-submit', AtcSubmit);

  if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.empty = true;
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.empty = false;
              this.innerHTML = recommendations.innerHTML;
              if(!recommendations.innerHTML.includes('data-recommend-check')){
                let recommendationAncestor = this.parentElement;
                while (recommendationAncestor && !recommendationAncestor.classList.contains('recommendation')) {
                  recommendationAncestor = recommendationAncestor.parentElement;
                }
                if(recommendationAncestor) recommendationAncestor.classList.add('hidden');
              }
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            if(this.empty) this.parentElement.classList.add('hidden');
          }
        );
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-cards"] && !Shopify.designMode) return;
  try {
    
  class StickerElement extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback(){
      const element = this.querySelector(this.dataset.selector);
      if(!element) return;
      const initialize = () => {
        const boundings = element.getBoundingClientRect();
        const height = boundings.height;
        this.style.setProperty('--element-height', (Math.round(height) + 'px'));
      }
      this.initLoad = setTimeout(initialize.bind(this), 2000);
      document.addEventListener('DOMContentLoaded', () => this.initLoad);
    }
  }
  if (!customElements.get('sticker-element')) { customElements.define('sticker-element', StickerElement); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-popup"]) return;
  try {
    
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if(!loader) return;
    if(state){
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease'
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease'
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      ) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
  };
  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if ((this.dataset.desktopHidden && window.screen.width > 991) || (this.dataset.mobileHidden && window.screen.width < 768)) return;
      this.button = this.querySelector('button');
      if(!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }
      const toggleModal = (event) => {
        event.preventDefault();
        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      }
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if(!customElements.get('modal-component-toggler')) customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalComponentPromotionPopup extends HTMLElement {
    constructor() {
      super();
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
      this.initPopupBehavior();
    }
    initPopupBehavior() {
      const storageKey = this.dataset.storageKey;
      const storageValue = this.dataset.storageValue || null;
      if (storageKey && localStorage.getItem(storageKey) === storageValue) {
        this.remove();
        return;
      }
      if (!window.location.href.includes('challenge') || !this.classList.contains('modal--active')) {
        if (this.dataset.trigger === 'self') {
          this.open();
          return;
        }
        this.onScroll = this.showOnScroll.bind(this);
        this.delay = parseInt(this.dataset.delay || "0", 10);
        window.addEventListener('scroll', this.onScroll);
      }
    }
    showOnScroll() {
      if (window.scrollY > this.delay) {
        window.removeEventListener('scroll', this.onScroll);
        this.open();
      }
    }
    doAnimate(){
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    }
    open(toggler = null){
      this.toggler = toggler;
      this.parent = this.parentElement;
      if(this.dataset.trigger !== 'self') document.body.append(this);
      this.setClasses(true);
      this.doAnimate();
      trapFocus(this.content);
      this.setListeners(true);
    }
    close(){
      if(this.dataset.trigger !== 'self'){
        document.body.removeChild(this);
        if(this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if(this.toggler){
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag){
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    setListeners(flag){
      if(this.dataset.hideOutside === 'false') return;
      switch(flag){
        case true:
          this.addEventListener('keyup', this.onKeyUp);
          this.addEventListener('click', this.onBodyClick);
          break;
        default:
          this.removeEventListener('keyup', this.onKeyUp);
          this.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onKeyUp(event){
      if(event.key === 'Escape') this.close();
    }
    onBodyClick(event){
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if(boundings.contains(target) || target === boundings) return;
      this.close();
    }
  }
  if(!customElements.get('modal-component-promotion-popup')) customElements.define('modal-component-promotion-popup', ModalComponentPromotionPopup);
  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', class CountdownTimer extends HTMLElement {
      constructor() {
        super();
        const endDate = new Date(this.getAttribute('end-date'));
        if (isNaN(endDate)) {
          this.classList.add('hidden');
          if(this.dataset.parent === 'true') this.parentElement.classList.add('hidden');
          const message = this.nextElementSibling;
          if(!message || !message.classList.contains('countdown-timer_message')) return;
          message.classList.remove('hidden');
          return;
        } else {
          const remainingTime = endDate.getTime() - Date.now();
          if (remainingTime <= 0) {
            this.innerHTML = `<div class="block"><span class="time">0</span><span class="text">${window.additionalStrings.countdown_days_label}</span></div><div class="block"><span class="time">0</span><span class="text">${window.additionalStrings.countdown_hours_label}</span></div><div class="block"><span class="time">0</span><span class="text">${window.additionalStrings.countdown_min_label}</span></div><div class="block"><span class="time">0</span><span class="text">${window.additionalStrings.countdown_sec_label}</span></div>`;
          } else {
            this.remainingTime = remainingTime;
            this.innerHTML = this.getTimeString();
          }
        }
      }

      connectedCallback() {
        if (isNaN(this.remainingTime)) {
          this.classList.add('hidden');
          if(this.dataset.parent === 'true') this.parentElement.classList.add('hidden');
          const message = this.nextElementSibling;
          if(!message || !message.classList.contains('countdown-timer_message')) return;
          message.classList.remove('hidden');
          return;
        }
        this.intervalId = setInterval(() => {
          this.remainingTime -= 1000;
          this.innerHTML = this.getTimeString();
          if (this.remainingTime <= 0) {
            clearInterval(this.intervalId);
            this.dispatchEvent(new Event('timeup'));
          }
        }, 1000);
      }

      getTimeString() {
        if (isNaN(this.remainingTime) || this.remainingTime <= 0) {
          this.classList.add('hidden');
          if(this.dataset.parent === 'true') this.parentElement.classList.add('hidden');
          const message = this.nextElementSibling;
          if(!message || !message.classList.contains('countdown-timer_message')) return;
          message.classList.remove('hidden');
          return;
        }
        const days = Math.floor(this.remainingTime / (1000 * 60 * 60 * 24));
        const hours = Math.floor((this.remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000);
        return `<div class="block"><span class="time">${days}</span><span class="text">${window.additionalStrings.countdown_days_label}</span></div><div class="block"><span class="time">${hours}</span><span class="text">${window.additionalStrings.countdown_hours_label}</span></div><div class="block"><span class="time">${minutes}</span><span class="text">${window.additionalStrings.countdown_min_label}</span></div><div class="block"><span class="time">${seconds}</span><span class="text">${window.additionalStrings.countdown_sec_label}</span></div>`;
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locations"] && !Shopify.designMode) return;
  try {
    
  class StoreDropdownComponent extends HTMLElement {
    constructor() {
      super();
      if(screen.width < 768) return;
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          const modal = this.closest('modal-component') || this.closest('.store-locations');
          const openDropdowns = modal
            ? [...modal.querySelectorAll('store-dropdown-component')].filter(
                d => d.button?.getAttribute('aria-expanded') === 'true'
              )
            : [];
          if (openDropdowns.length === 1 && openDropdowns[0] === this) {
            return;
          }
          return this.closeDropdown();
        }
        this.openDropdown();
      });
    }

    connectedCallback() {
      if(screen.width < 768) return;
      const self = this;
      const getModalDropdowns = () => {
        return self.closest('modal-component')?.querySelectorAll('store-dropdown-component') || self.closest('.store-locations')?.querySelectorAll('store-dropdown-component') || [];
      };
      const closeAllDropdowns = () => {
        const siblings = getModalDropdowns();
        siblings.forEach(dropdown => {
          if (dropdown !== self && dropdown.button?.getAttribute('aria-expanded') === 'true') {
            if (typeof dropdown.closeDropdown === 'function') {
              dropdown.closeDropdown({ force: true });
            } else {
              dropdown.button.setAttribute('aria-expanded', false);
              dropdown.content.classList.remove('dropdown--open', 'widget--styles');
              document.body.removeEventListener('click', dropdown._onBodyClick);
            }
          }
        });
      };
      const openDropdown = () => {
        closeAllDropdowns();
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open', 'widget--styles');
        self._onBodyClick = onBodyClick;
        document.body.addEventListener('click', onBodyClick);
      };
      const closeDropdown = (opts = {}) => {
        const force = Boolean(opts.force);
        if (!force) {
          const openDropdowns = [...getModalDropdowns()].filter(
            d => d.button?.getAttribute('aria-expanded') === 'true'
          );
          if (openDropdowns.length === 1 && openDropdowns[0] === self) return;
        }
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open', 'widget--styles');
        document.body.removeEventListener('click', onBodyClick);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('store-dropdown-component')) { customElements.define('store-dropdown-component', StoreDropdownComponent); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator-popup"] && !Shopify.designMode) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      ) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class ModalComponentToggler extends HTMLElement {
    constructor() {
      super();
      if ((this.dataset.desktopHidden && window.screen.width > 991) || (this.dataset.mobileHidden && window.screen.width < 768)) return;
      this.button = this.querySelector('button');
      if(!this.button) return;
      const open = (modal) => {
        modal.open(this.button);
        this.button.setAttribute('data-expanded', 'true');
      }
      const toggleModal = (event) => {
        event.preventDefault();
        if(this.dataset.storage === 'true') localStorage.setItem(this.dataset.storageKey, this.dataset.storageValue);
        const modal = document.querySelector(`[data-modal="${this.button.dataset.modalRef}"]`);
        if(this.button.dataset.expanded === 'true') return modal.close();
        open(modal);
      }
      this.button.addEventListener('click', toggleModal.bind(this));
    }
  }
  if(!customElements.get('modal-component-toggler')) customElements.define('modal-component-toggler', ModalComponentToggler);
  class ModalStoreComponent extends HTMLElement {
    constructor() {
      super();
      this.toggler = null;
      this.parent = null;
      this.content = this.querySelector('.modal-component');
      this.animatorWrap = this.querySelector('[data-modal-animator-wrap]');
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onBodyClick = this.onBodyClick.bind(this);
    }
    open(toggler = null){
      this.toggler = toggler;
      this.parent = this.parentElement;
      if(this.dataset.trigger !== 'self') document.body.append(this);
      this.setClasses(true);
      this.doAnimate();
      trapFocus(this.content);
      this.setListeners(true);
    }
    doAnimate(){
      const parseJSON = (key) => {
        try {
          return JSON.parse(this.animatorWrap.dataset[key]);
        } catch (e) {
          console.warn(`Invalid or missing data-${key} on element:`, this.animatorWrap);
          return null;
        }
      };
      const animationFrames = parseJSON('frames');
      const timing = parseJSON('options');
      if (!animationFrames || !timing) return;
      this.animatorWrap.animate(animationFrames, timing);
    };
    close(){
      if(this.dataset.trigger !== 'self'){
        document.body.removeChild(this);
        if(this.parent) this.parent.append(this);
      }
      this.setClasses(false);
      if(this.toggler){
        this.toggler.setAttribute('data-expanded', 'false');
        trapFocus(null, this.toggler, false);
      }
      this.toggler = null;
      this.parent = null;
      this.setListeners(false);
    }
    setClasses(flag){
      this.classList.toggle('modal--active', flag);
      document.body.classList.toggle(`${this.dataset.modal}--modal-active`, flag);
      document.body.classList.toggle('overflow-hidden', flag);
    }
    setListeners(flag){
      if(this.dataset.hideOutside === 'false') return;
      switch(flag){
        case true:
          this.addEventListener('keyup', this.onKeyUp);
          this.addEventListener('click', this.onBodyClick);
          break;
        default:
          this.removeEventListener('keyup', this.onKeyUp);
          this.removeEventListener('click', this.onBodyClick);
          break;
      }
    }
    onBodyClick(event){
      const target = event.target;
      const boundings = this.querySelector('.modal-component_body');
      if(boundings.contains(target) || target === boundings) return;
      this.close();
    }
    onKeyUp(event){
      if(event.key === 'Escape') this.close();
    }
  }
  if(!customElements.get('modal-store-component')) customElements.define('modal-store-component', ModalStoreComponent);
  
  class StoreDropdownComponent extends HTMLElement {
    constructor() {
      super();
      if(screen.width < 768) return;
      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          const modal = this.closest('modal-store-component') || this.closest('.store-locations');
          const openDropdowns = modal
            ? [...modal.querySelectorAll('store-dropdown-component')].filter(
                d => d.button?.getAttribute('aria-expanded') === 'true'
              )
            : [];
          if (openDropdowns.length === 1 && openDropdowns[0] === this) {
            return;
          }
          return this.closeDropdown();
        }
        this.openDropdown();
      });
    }

    connectedCallback() {
      if(screen.width < 768) return;
      const self = this;
      const getModalDropdowns = () => {
        return self.closest('modal-store-component')?.querySelectorAll('store-dropdown-component') || self.closest('.store-locations')?.querySelectorAll('store-dropdown-component') || [];
      };
      const closeAllDropdowns = () => {
        const siblings = getModalDropdowns();
        siblings.forEach(dropdown => {
          if (dropdown !== self && dropdown.button?.getAttribute('aria-expanded') === 'true') {
            if (typeof dropdown.closeDropdown === 'function') {
              dropdown.closeDropdown({ force: true });
            } else {
              dropdown.button.setAttribute('aria-expanded', false);
              dropdown.content.classList.remove('dropdown--open', 'widget--styles');
              document.body.removeEventListener('click', dropdown._onBodyClick);
            }
          }
        });
      };
      const openDropdown = () => {
        closeAllDropdowns();
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open', 'widget--styles');
        self._onBodyClick = onBodyClick;
        document.body.addEventListener('click', onBodyClick);
      };
      const closeDropdown = (opts = {}) => {
        const force = Boolean(opts.force);
        if (!force) {
          const openDropdowns = [...getModalDropdowns()].filter(
            d => d.button?.getAttribute('aria-expanded') === 'true'
          );
          if (openDropdowns.length === 1 && openDropdowns[0] === self) return;
        }
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open', 'widget--styles');
        document.body.removeEventListener('click', onBodyClick);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        ) return;
        closeDropdown();
      };
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('store-dropdown-component')) { customElements.define('store-dropdown-component', StoreDropdownComponent); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      ) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  class LocalizationDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      if (!this.button || !this.content) return;
      this.items = this.content.querySelectorAll('[data-submit-btn]');
      if (!this.items) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            console.warn(`Invalid or missing data-${key} on element:`, self.content);
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const select = (event) => {
        event.preventDefault();
        const form = document.getElementById(self.dataset.formId);
        const input = self.querySelector('[data-submit-input]');
        if (!input || !form) return;
        input.value = event.currentTarget.dataset.value;
        form.submit();
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
        self.items.forEach((item) => item.addEventListener('click', select));
      };
      const closeDropdown = () => {
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        trapFocus(null, self.button, false);
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
        self.items.forEach((item) => item.removeEventListener('click', select));
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          target === self.button && self.button.getAttribute('aria-expanded') === 'true'
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        closeDropdown();
      };
      this.select = select;
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('localization-dropdown')) { customElements.define('localization-dropdown', LocalizationDropdown); }

  } catch(e) { console.error(e); }
})();
})();
